/* eslint-disable */  
/// <reference path="./custom.d.ts" />
// tslint:disable
// @ts-nocheck
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import {Configuration} from "./configuration";

const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AccountBean
 */
export interface AccountBean {
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    role: AccountBean.RoleEnum;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccountBean
     */
    agencyPageUrlEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccountBean
     */
    pageUrlEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    activeSites?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    lastLoginDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    lastTrafficDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    status?: AccountBean.StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    last30DaysRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountBean
     */
    percentToPrevious30Days?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountBean
     */
    accessRights: AccountBean.AccessRightsEnum;
}

/**
 * @export
 * @namespace AccountBean
 */
export namespace AccountBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        Customer = <any> 'customer',
        TeamOwner = <any> 'team_owner',
        TeamAdmin = <any> 'team_admin',
        TeamMember = <any> 'team_member'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ACTIVE = <any> 'ACTIVE',
        HOLD = <any> 'HOLD'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AccessRightsEnum {
        FULL = <any> 'FULL',
        READONLY = <any> 'READ_ONLY'
    }
}
/**
 * 
 * @export
 * @interface AdRequestsBean
 */
export interface AdRequestsBean {
    /**
     * 
     * @type {number}
     * @memberof AdRequestsBean
     */
    requests?: number;
}
/**
 * 
 * @export
 * @interface AdTypeChartData
 */
export interface AdTypeChartData {
    /**
     * 
     * @type {Array<AdTypeHistoryBean>}
     * @memberof AdTypeChartData
     */
    adTypeStats: Array<AdTypeHistoryBean>;
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof AdTypeChartData
     */
    axisX: Array<AxisLabel>;
}
/**
 * 
 * @export
 * @interface AdTypeHistoryBean
 */
export interface AdTypeHistoryBean {
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    bidsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    winsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    impressionsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    revenueHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    eCPMHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    bidPriceHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    winRateHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {string}
     * @memberof AdTypeHistoryBean
     */
    mediaType: string;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof AdTypeHistoryBean
     */
    ecpmhistory?: Array<StatValueSnapshot>;
}
/**
 * 
 * @export
 * @interface AdUnitDictBean
 */
export interface AdUnitDictBean {
    /**
     * 
     * @type {number}
     * @memberof AdUnitDictBean
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitDictBean
     */
    accountId?: number;
    /**
     * 
     * @type {number}
     * @memberof AdUnitDictBean
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof AdUnitDictBean
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof AdUnitDictBean
     */
    adUnitCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AdUnitDictBean
     */
    adUnitName?: string;
}
/**
 * 
 * @export
 * @interface AdminBean
 */
export interface AdminBean {
    /**
     * 
     * @type {number}
     * @memberof AdminBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminBean
     */
    adminType: AdminBean.AdminTypeEnum;
}

/**
 * @export
 * @namespace AdminBean
 */
export namespace AdminBean {
    /**
     * @export
     * @enum {string}
     */
    export enum AdminTypeEnum {
        PRIMARY = <any> 'ADMIN_PRIMARY',
        SECONDARY = <any> 'ADMIN_SECONDARY'
    }
}
/**
 * 
 * @export
 * @interface AgencyBean
 */
export interface AgencyBean {
    /**
     * 
     * @type {number}
     * @memberof AgencyBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    stringId: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    status: AgencyBean.StatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    advancedDashboardFilters: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    pageUrlEnabled: boolean;
    /**
     * 
     * @type {ManagerBean}
     * @memberof AgencyBean
     */
    manager?: ManagerBean;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    agencyDomains?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    publisherDomains?: string;
    /**
     * 
     * @type {string}
     * @memberof AgencyBean
     */
    endpointDomains?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AgencyBean
     */
    multiplyOnSampling?: boolean;
}

/**
 * @export
 * @namespace AgencyBean
 */
export namespace AgencyBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ACTIVE = <any> 'ACTIVE',
        HOLD = <any> 'HOLD'
    }
}
/**
 * 
 * @export
 * @interface AgencyPreferences
 */
export interface AgencyPreferences {
    /**
     * 
     * @type {boolean}
     * @memberof AgencyPreferences
     */
    multiplyOnSampling?: boolean;
}
/**
 * 
 * @export
 * @interface AlertBean
 */
export interface AlertBean {
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    alertDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    alertConfigId?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    alertConfigName?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    granularity?: AlertBean.GranularityEnum;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    adUnitDictName?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    previousDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    previousValue?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertBean
     */
    currentDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    currentValue?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertBean
     */
    deviation?: number;
}

/**
 * @export
 * @namespace AlertBean
 */
export namespace AlertBean {
    /**
     * @export
     * @enum {string}
     */
    export enum GranularityEnum {
        Total = <any> 'Total',
        PerSite = <any> 'PerSite',
        PerAdUnit = <any> 'PerAdUnit'
    }
}
/**
 * 
 * @export
 * @interface AlertConfigBean
 */
export interface AlertConfigBean {
    /**
     * 
     * @type {number}
     * @memberof AlertConfigBean
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AlertConfigBean
     */
    accountId?: number;
    /**
     * 
     * @type {string}
     * @memberof AlertConfigBean
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertConfigBean
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertConfigBean
     */
    alertType?: AlertConfigBean.AlertTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AlertConfigBean
     */
    granularity?: AlertConfigBean.GranularityEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AlertConfigBean
     */
    siteIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertConfigBean
     */
    siteNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AlertConfigBean
     */
    adUnitIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertConfigBean
     */
    adUnitNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AlertConfigBean
     */
    thresholdValue?: number;
    /**
     * 
     * @type {number}
     * @memberof AlertConfigBean
     */
    thresholdPercent?: number;
}

/**
 * @export
 * @namespace AlertConfigBean
 */
export namespace AlertConfigBean {
    /**
     * @export
     * @enum {string}
     */
    export enum AlertTypeEnum {
        PrebidRevenueDropped = <any> 'PrebidRevenueDropped',
        AdRequestEcpmDropped = <any> 'AdRequestEcpmDropped',
        TimeOutRateChanges = <any> 'TimeOutRateChanges'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum GranularityEnum {
        Total = <any> 'Total',
        PerSite = <any> 'PerSite',
        PerAdUnit = <any> 'PerAdUnit'
    }
}
/**
 * 
 * @export
 * @interface AlertNotificationBean
 */
export interface AlertNotificationBean {
    /**
     * 
     * @type {number}
     * @memberof AlertNotificationBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AlertNotificationBean
     */
    name?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AlertNotificationBean
     */
    alertConfigIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertNotificationBean
     */
    alertConfigNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AlertNotificationBean
     */
    emails?: string;
    /**
     * 
     * @type {string}
     * @memberof AlertNotificationBean
     */
    lastSentDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AlertNotificationBean
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContext
 */
export interface ApplicationContext {
    /**
     * 
     * @type {ApplicationContext}
     * @memberof ApplicationContext
     */
    parent?: ApplicationContext;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    startupDate?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContext
     */
    applicationName?: string;
    /**
     * 
     * @type {AutowireCapableBeanFactory}
     * @memberof ApplicationContext
     */
    autowireCapableBeanFactory?: AutowireCapableBeanFactory;
    /**
     * 
     * @type {Environment}
     * @memberof ApplicationContext
     */
    environment?: Environment;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationContext
     */
    beanDefinitionNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ApplicationContext
     */
    beanDefinitionCount?: number;
    /**
     * 
     * @type {BeanFactory}
     * @memberof ApplicationContext
     */
    parentBeanFactory?: BeanFactory;
    /**
     * 
     * @type {ApplicationContextClassLoader}
     * @memberof ApplicationContext
     */
    classLoader?: ApplicationContextClassLoader;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoader
 */
export interface ApplicationContextClassLoader {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoader
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    registeredAsParallelCapable?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParent}
     * @memberof ApplicationContextClassLoader
     */
    parent?: ApplicationContextClassLoaderParent;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoader
     */
    unnamedModule?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>}
     * @memberof ApplicationContextClassLoader
     */
    definedPackages?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoader
     */
    defaultAssertionStatus?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParent
 */
export interface ApplicationContextClassLoaderParent {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParent
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    registeredAsParallelCapable?: boolean;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModule}
     * @memberof ApplicationContextClassLoaderParent
     */
    unnamedModule?: ApplicationContextClassLoaderParentUnnamedModule;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>}
     * @memberof ApplicationContextClassLoaderParent
     */
    definedPackages?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParent
     */
    defaultAssertionStatus?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModule
 */
export interface ApplicationContextClassLoaderParentUnnamedModule {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    name?: string;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleClassLoader}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    classLoader?: ApplicationContextClassLoaderParentUnnamedModuleClassLoader;
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleDescriptor}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    descriptor?: ApplicationContextClassLoaderParentUnnamedModuleDescriptor;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    named?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    annotations?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    declaredAnnotations?: Array<any>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    packages?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof ApplicationContextClassLoaderParentUnnamedModule
     */
    layer?: any;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleClassLoader
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleClassLoader {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    registeredAsParallelCapable?: boolean;
    /**
     * 
     * @type {Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    definedPackages?: Array<ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoader
     */
    defaultAssertionStatus?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages {
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    name?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    annotations?: Array<any>;
    /**
     * 
     * @type {Array<any>}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    declaredAnnotations?: Array<any>;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    sealed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    specificationTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    specificationVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    specificationVendor?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    implementationTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    implementationVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleClassLoaderDefinedPackages
     */
    implementationVendor?: string;
}
/**
 * 
 * @export
 * @interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor
 */
export interface ApplicationContextClassLoaderParentUnnamedModuleDescriptor {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    open?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationContextClassLoaderParentUnnamedModuleDescriptor
     */
    automatic?: boolean;
}
/**
 * 
 * @export
 * @interface AutowireCapableBeanFactory
 */
export interface AutowireCapableBeanFactory {
}
/**
 * 
 * @export
 * @interface AxisLabel
 */
export interface AxisLabel {
    /**
     * 
     * @type {string}
     * @memberof AxisLabel
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof AxisLabel
     */
    formattedValue: string;
    /**
     * 
     * @type {number}
     * @memberof AxisLabel
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof AxisLabel
     */
    position: number;
}
/**
 * 
 * @export
 * @interface BasicReportQuery
 */
export interface BasicReportQuery {
    /**
     * 
     * @type {Date}
     * @memberof BasicReportQuery
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof BasicReportQuery
     */
    endDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BasicReportQuery
     */
    timeGrouping: BasicReportQuery.TimeGroupingEnum;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByAccountId?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupBySite?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByBidder?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByAdUnit?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByMediaType?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByDevice?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCountry?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByUtmSource?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByUtmMedium?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByUtmCampaign?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByUtmTerm?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByUtmContent?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByHbSource?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByPageUrl?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByRefererUrl?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByPlatform?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByBrowser?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByVersion?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByTcfCompliant?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupBySamplingRate?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupBySiteName?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByWorkspace?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCrmId?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCustomField1?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCustomField2?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCustomField3?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCustomField4?: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof BasicReportQuery
     */
    groupByCustomField5?: UIXValueBoolean;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BasicReportQuery
     */
    sites?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    workspaces?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    crmIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    bidders?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BasicReportQuery
     */
    adUnits?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    mediaTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    versions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    tcfCompliants?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    samplingRates?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    accountIds?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BasicReportQuery
     */
    devices?: Array<FilterBean>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BasicReportQuery
     */
    countries?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    customFilter1?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    customFilter2?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    customFilter3?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    customFilter4?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    customFilter5?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BasicReportQuery
     */
    metrics?: Array<BasicReportQuery.MetricsEnum>;
}

/**
 * @export
 * @namespace BasicReportQuery
 */
export namespace BasicReportQuery {
    /**
     * @export
     * @enum {string}
     */
    export enum TimeGroupingEnum {
        Total = <any> 'Total',
        Daily = <any> 'Daily',
        Hourly = <any> 'Hourly'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MetricsEnum {
        SiteRequests = <any> 'siteRequests',
        AdUnitRequests = <any> 'adUnitRequests',
        Impressions = <any> 'impressions',
        Bids = <any> 'bids',
        Wins = <any> 'wins',
        Timeouts = <any> 'timeouts',
        Auctions = <any> 'auctions',
        BidRequests = <any> 'bidRequests',
        UsdRevenue = <any> 'usdRevenue',
        UsdUnaffectedRevenue = <any> 'usdUnaffectedRevenue',
        UsdEcpm = <any> 'usdEcpm',
        UsdBidPrice = <any> 'usdBidPrice',
        EurRevenue = <any> 'eurRevenue',
        EurUnaffectedRevenue = <any> 'eurUnaffectedRevenue',
        EurEcpm = <any> 'eurEcpm',
        EurBidPrice = <any> 'eurBidPrice',
        Revenue = <any> 'revenue',
        ECPM = <any> 'eCPM',
        BidPrice = <any> 'bidPrice',
        UsdBidPriceSum = <any> 'usdBidPriceSum',
        EurBidPriceSum = <any> 'eurBidPriceSum',
        BidRate = <any> 'bidRate',
        TimeoutRate = <any> 'timeoutRate',
        WinRate = <any> 'winRate',
        AuctionWins = <any> 'auctionWins',
        WinCpmUsd = <any> 'winCpmUsd',
        WinCpmEur = <any> 'winCpmEur',
        SecondWinCpmUsd = <any> 'secondWinCpmUsd',
        SecondWinCpmEur = <any> 'secondWinCpmEur'
    }
}
/**
 * 
 * @export
 * @interface BeanFactory
 */
export interface BeanFactory {
}
/**
 * 
 * @export
 * @interface BidderHistoryBean
 */
export interface BidderHistoryBean {
    /**
     * 
     * @type {string}
     * @memberof BidderHistoryBean
     */
    bidderName: string;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    usdRevenueHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    eurRevenueHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    usdBidPriceHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    eurBidPriceHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    usdEcpmHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    eurEcpmHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    bidRateHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    winRateHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    timeoutsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof BidderHistoryBean
     */
    timeoutRateHistory: Array<StatValueSnapshot>;
}
/**
 * 
 * @export
 * @interface BidderMetricsQuery
 */
export interface BidderMetricsQuery {
    /**
     * 
     * @type {Date}
     * @memberof BidderMetricsQuery
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof BidderMetricsQuery
     */
    endDate: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    bidders?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BidderMetricsQuery
     */
    sites?: Array<FilterBean>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BidderMetricsQuery
     */
    adUnits?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    mediaTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BidderMetricsQuery
     */
    devices?: Array<FilterBean>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof BidderMetricsQuery
     */
    countries?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    browsers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    utmSources?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    utmMediums?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    utmCampaigns?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    versions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    tcfCompliants?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BidderMetricsQuery
     */
    samplingRates?: Array<string>;
}
/**
 * 
 * @export
 * @interface BiddersMetricByTime
 */
export interface BiddersMetricByTime {
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof BiddersMetricByTime
     */
    axisX: Array<AxisLabel>;
    /**
     * 
     * @type {Array<BidderHistoryBean>}
     * @memberof BiddersMetricByTime
     */
    biddersData: Array<BidderHistoryBean>;
}
/**
 * 
 * @export
 * @interface BootstrapStatusLabel
 */
export interface BootstrapStatusLabel {
    /**
     * 
     * @type {string}
     * @memberof BootstrapStatusLabel
     */
    status: BootstrapStatusLabel.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BootstrapStatusLabel
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BootstrapStatusLabel
     */
    tooltip: string;
    /**
     * 
     * @type {number}
     * @memberof BootstrapStatusLabel
     */
    progress: number;
}

/**
 * @export
 * @namespace BootstrapStatusLabel
 */
export namespace BootstrapStatusLabel {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Success = <any> 'success',
        Info = <any> 'info',
        Warning = <any> 'warning',
        Danger = <any> 'danger',
        Secondary = <any> 'secondary',
        Primary = <any> 'primary',
        Disabled = <any> 'disabled',
        Error = <any> 'error'
    }
}
/**
 * 
 * @export
 * @interface BundleCreateForm
 */
export interface BundleCreateForm {
    /**
     * 
     * @type {number}
     * @memberof BundleCreateForm
     */
    teamId?: number;
    /**
     * 
     * @type {number}
     * @memberof BundleCreateForm
     */
    siteId?: number;
    /**
     * 
     * @type {UIXValueString}
     * @memberof BundleCreateForm
     */
    name: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof BundleCreateForm
     */
    domain: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof BundleCreateForm
     */
    tags: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof BundleCreateForm
     */
    description: UIXValueString;
    /**
     * 
     * @type {UIXValueInteger}
     * @memberof BundleCreateForm
     */
    pageLayoutId: UIXValueInteger;
    /**
     * 
     * @type {string}
     * @memberof BundleCreateForm
     */
    prebidVersion: string;
    /**
     * 
     * @type {boolean}
     * @memberof BundleCreateForm
     */
    hasApprovedBidders: boolean;
    /**
     * 
     * @type {number}
     * @memberof BundleCreateForm
     */
    bundleId?: number;
    /**
     * 
     * @type {string}
     * @memberof BundleCreateForm
     */
    adUnitId?: string;
}
/**
 * 
 * @export
 * @interface BundleCreateResponseAdmin
 */
export interface BundleCreateResponseAdmin {
    /**
     * 
     * @type {BundleCreateForm}
     * @memberof BundleCreateResponseAdmin
     */
    form?: BundleCreateForm;
    /**
     * 
     * @type {number}
     * @memberof BundleCreateResponseAdmin
     */
    bundleId?: number;
    /**
     * 
     * @type {string}
     * @memberof BundleCreateResponseAdmin
     */
    bundleKey?: string;
}
/**
 * 
 * @export
 * @interface BundleTrafficHealth
 */
export interface BundleTrafficHealth {
    /**
     * 
     * @type {number}
     * @memberof BundleTrafficHealth
     */
    activeBundlesNum: number;
    /**
     * 
     * @type {number}
     * @memberof BundleTrafficHealth
     */
    bundlesNum: number;
    /**
     * 
     * @type {string}
     * @memberof BundleTrafficHealth
     */
    activeBundlesPercentFormatted: string;
    /**
     * 
     * @type {string}
     * @memberof BundleTrafficHealth
     */
    bundlesHealthState: BundleTrafficHealth.BundlesHealthStateEnum;
}

/**
 * @export
 * @namespace BundleTrafficHealth
 */
export namespace BundleTrafficHealth {
    /**
     * @export
     * @enum {string}
     */
    export enum BundlesHealthStateEnum {
        Ok = <any> 'ok',
        Normal = <any> 'normal',
        Bad = <any> 'bad',
        NotStarted = <any> 'notStarted'
    }
}
/**
 * 
 * @export
 * @interface ChangePasswordBean
 */
export interface ChangePasswordBean {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBean
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBean
     */
    newPassword?: string;
}
/**
 * 
 * @export
 * @interface ClientBlockBean
 */
export interface ClientBlockBean {
    /**
     * 
     * @type {string}
     * @memberof ClientBlockBean
     */
    cancelReason?: ClientBlockBean.CancelReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientBlockBean
     */
    cancelComments?: string;
}

/**
 * @export
 * @namespace ClientBlockBean
 */
export namespace ClientBlockBean {
    /**
     * @export
     * @enum {string}
     */
    export enum CancelReasonEnum {
        HIGHPRICES = <any> 'HIGH_PRICES',
        INSUFFICIENTFUNCTIONALITY = <any> 'INSUFFICIENT_FUNCTIONALITY',
        BADUI = <any> 'BAD_UI',
        LOWCALCULATIONACCURACY = <any> 'LOW_CALCULATION_ACCURACY',
        LONGLOAD = <any> 'LONG_LOAD',
        DIFFICULTSETUP = <any> 'DIFFICULT_SETUP',
        NOTWHATISNEEDED = <any> 'NOT_WHAT_IS_NEEDED',
        OTHER = <any> 'OTHER'
    }
}
/**
 * 
 * @export
 * @interface ContactSupportForm
 */
export interface ContactSupportForm {
    /**
     * 
     * @type {string}
     * @memberof ContactSupportForm
     */
    issueType: string;
    /**
     * 
     * @type {string}
     * @memberof ContactSupportForm
     */
    description: string;
}
/**
 * 
 * @export
 * @interface CustomFilterBean
 */
export interface CustomFilterBean {
    /**
     * 
     * @type {number}
     * @memberof CustomFilterBean
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CustomFilterBean
     */
    fieldId: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFilterBean
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomFilterBean
     */
    dashboardFilter: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomFilterBean
     */
    adapterConfigField: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFilterBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {Array<CustomFilterValueBean>}
     * @memberof CustomFilterBean
     */
    customFilterValues?: Array<CustomFilterValueBean>;
}
/**
 * 
 * @export
 * @interface CustomFilterValueBean
 */
export interface CustomFilterValueBean {
    /**
     * 
     * @type {number}
     * @memberof CustomFilterValueBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomFilterValueBean
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CustomFilterValueBean
     */
    value: string;
}
/**
 * 
 * @export
 * @interface CustomFiltersBean
 */
export interface CustomFiltersBean {
    /**
     * 
     * @type {Array<CustomFilterBean>}
     * @memberof CustomFiltersBean
     */
    customFilters: Array<CustomFilterBean>;
}
/**
 * 
 * @export
 * @interface CustomLogoBody
 */
export interface CustomLogoBody {
    /**
     * 
     * @type {Blob}
     * @memberof CustomLogoBody
     */
    logo: Blob;
}
/**
 * 
 * @export
 * @interface CustomerBean
 */
export interface CustomerBean {
    /**
     * 
     * @type {number}
     * @memberof CustomerBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBean
     */
    emailIsConfirmed: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    emailConfirmationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    cardBrand?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    lastCard4Digits?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBean
     */
    inTrial: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    billingProblem?: CustomerBean.BillingProblemEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    billingProblemDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    billingStartDate?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerBean
     */
    paidUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerBean
     */
    failedPayUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerBean
     */
    lastTrafficHoursAgo?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    lastLoginDate?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerBean
     */
    logins?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    billingPlan?: CustomerBean.BillingPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    cancelReason?: CustomerBean.CancelReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerBean
     */
    cancelComments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerBean
     */
    customPaymentEnabled: boolean;
}

/**
 * @export
 * @namespace CustomerBean
 */
export namespace CustomerBean {
    /**
     * @export
     * @enum {string}
     */
    export enum BillingProblemEnum {
        NoRegisteredCard = <any> 'NoRegisteredCard',
        UnexpectedError = <any> 'UnexpectedError',
        CardDeclined = <any> 'CardDeclined',
        AdminBlock = <any> 'AdminBlock',
        DailyImprsExceeded = <any> 'DailyImprsExceeded',
        ClientBlock = <any> 'ClientBlock',
        AuthRequired = <any> 'AuthRequired'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum BillingPlanEnum {
        FIXEDDAYIMPRS = <any> 'FIXED_DAY_IMPRS',
        FIXEDDAYIMPRS20 = <any> 'FIXED_DAY_IMPRS_20',
        CPM = <any> 'CPM',
        CUSTOM = <any> 'CUSTOM'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CancelReasonEnum {
        HIGHPRICES = <any> 'HIGH_PRICES',
        INSUFFICIENTFUNCTIONALITY = <any> 'INSUFFICIENT_FUNCTIONALITY',
        BADUI = <any> 'BAD_UI',
        LOWCALCULATIONACCURACY = <any> 'LOW_CALCULATION_ACCURACY',
        LONGLOAD = <any> 'LONG_LOAD',
        DIFFICULTSETUP = <any> 'DIFFICULT_SETUP',
        NOTWHATISNEEDED = <any> 'NOT_WHAT_IS_NEEDED',
        OTHER = <any> 'OTHER'
    }
}
/**
 * 
 * @export
 * @interface CustomersSearchQueryBean
 */
export interface CustomersSearchQueryBean {
    /**
     * 
     * @type {string}
     * @memberof CustomersSearchQueryBean
     */
    customerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomersSearchQueryBean
     */
    billingProblem?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomersSearchQueryBean
     */
    billingPlan?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomersSearchQueryBean
     */
    defaultAgency?: boolean;
}
/**
 * 
 * @export
 * @interface CustomersStatBean
 */
export interface CustomersStatBean {
    /**
     * 
     * @type {Date}
     * @memberof CustomersStatBean
     */
    eventDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CustomersStatBean
     */
    registered: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersStatBean
     */
    confirmed: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersStatBean
     */
    billingStarted: number;
}
/**
 * 
 * @export
 * @interface CustomersStatQuery
 */
export interface CustomersStatQuery {
    /**
     * 
     * @type {Date}
     * @memberof CustomersStatQuery
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomersStatQuery
     */
    end: Date;
}
/**
 * 
 * @export
 * @interface DashboardBean
 */
export interface DashboardBean {
    /**
     * 
     * @type {boolean}
     * @memberof DashboardBean
     */
    partnerInstallation?: boolean;
    /**
     * 
     * @type {Statistics}
     * @memberof DashboardBean
     */
    statistics: Statistics;
    /**
     * 
     * @type {Statistics}
     * @memberof DashboardBean
     */
    previousPeriodStatistics: Statistics;
}
/**
 * 
 * @export
 * @interface DashboardQuery
 */
export interface DashboardQuery {
    /**
     * 
     * @type {Date}
     * @memberof DashboardQuery
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof DashboardQuery
     */
    endDate: Date;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof DashboardQuery
     */
    sites?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    bidders?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof DashboardQuery
     */
    adUnits?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    mediaTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    browsers?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof DashboardQuery
     */
    devices?: Array<FilterBean>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof DashboardQuery
     */
    countries?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    versions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    tcfCompliants?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    samplingRates?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    customFilter1?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    customFilter2?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    customFilter3?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    customFilter4?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardQuery
     */
    customFilter5?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DashboardQuery
     */
    sumMetric?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardQuery
     */
    dashboardCurrency?: string;
}
/**
 * 
 * @export
 * @interface Environment
 */
export interface Environment {
    /**
     * 
     * @type {Array<string>}
     * @memberof Environment
     */
    defaultProfiles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Environment
     */
    activeProfiles?: Array<string>;
}
/**
 * 
 * @export
 * @interface FieldChartQuery
 */
export interface FieldChartQuery {
    /**
     * 
     * @type {Date}
     * @memberof FieldChartQuery
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof FieldChartQuery
     */
    endDate: Date;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof FieldChartQuery
     */
    sites?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    bidders?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof FieldChartQuery
     */
    adUnits?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    mediaTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    sizes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    browsers?: Array<string>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof FieldChartQuery
     */
    devices?: Array<FilterBean>;
    /**
     * 
     * @type {Array<FilterBean>}
     * @memberof FieldChartQuery
     */
    countries?: Array<FilterBean>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    versions?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    tcfCompliants?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    samplingRates?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    customFilter1?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    customFilter2?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    customFilter3?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    customFilter4?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    customFilter5?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FieldChartQuery
     */
    sumMetric?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldChartQuery
     */
    dashboardCurrency?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldChartQuery
     */
    metrics?: Array<string>;
}
/**
 * 
 * @export
 * @interface FilterBean
 */
export interface FilterBean {
    /**
     * 
     * @type {string}
     * @memberof FilterBean
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FilterBean
     */
    value: string;
}
/**
 * 
 * @export
 * @interface FilterRegistration
 */
export interface FilterRegistration {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRegistration
     */
    urlPatternMappings?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRegistration
     */
    servletNameMappings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof FilterRegistration
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRegistration
     */
    className?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof FilterRegistration
     */
    initParameters?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface FunnelChartData
 */
export interface FunnelChartData {
    /**
     * 
     * @type {Array<FunnelChartDataBean>}
     * @memberof FunnelChartData
     */
    dataBeans: Array<FunnelChartDataBean>;
}
/**
 * 
 * @export
 * @interface FunnelChartDataBean
 */
export interface FunnelChartDataBean {
    /**
     * 
     * @type {string}
     * @memberof FunnelChartDataBean
     */
    parameterName: string;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof FunnelChartDataBean
     */
    parameterStats: Array<OverviewStatisticsBean>;
}
/**
 * 
 * @export
 * @interface HealthMonitorBean
 */
export interface HealthMonitorBean {
    /**
     * 
     * @type {BundleTrafficHealth}
     * @memberof HealthMonitorBean
     */
    bundleTrafficHealth: BundleTrafficHealth;
}
/**
 * 
 * @export
 * @interface HttpStatusCode
 */
export interface HttpStatusCode {
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    error?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    is4xxClientError?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    is5xxServerError?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    is3xxRedirection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    is1xxInformational?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HttpStatusCode
     */
    is2xxSuccessful?: boolean;
}
/**
 * 
 * @export
 * @interface IncrementalRevenueChartData
 */
export interface IncrementalRevenueChartData {
    /**
     * 
     * @type {Array<string>}
     * @memberof IncrementalRevenueChartData
     */
    labels: Array<string>;
    /**
     * 
     * @type {Array<YValuesDouble>}
     * @memberof IncrementalRevenueChartData
     */
    usdValues: Array<YValuesDouble>;
    /**
     * 
     * @type {Array<YValuesDouble>}
     * @memberof IncrementalRevenueChartData
     */
    eurValues: Array<YValuesDouble>;
}
/**
 * 
 * @export
 * @interface ItemResponseAccountBean
 */
export interface ItemResponseAccountBean {
    /**
     * 
     * @type {AccountBean}
     * @memberof ItemResponseAccountBean
     */
    data: AccountBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAccountBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdUnitDictBean
 */
export interface ItemResponseAdUnitDictBean {
    /**
     * 
     * @type {AdUnitDictBean}
     * @memberof ItemResponseAdUnitDictBean
     */
    data: AdUnitDictBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdUnitDictBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAdminBean
 */
export interface ItemResponseAdminBean {
    /**
     * 
     * @type {AdminBean}
     * @memberof ItemResponseAdminBean
     */
    data: AdminBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAdminBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAgencyBean
 */
export interface ItemResponseAgencyBean {
    /**
     * 
     * @type {AgencyBean}
     * @memberof ItemResponseAgencyBean
     */
    data: AgencyBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAgencyBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAlertBean
 */
export interface ItemResponseAlertBean {
    /**
     * 
     * @type {AlertBean}
     * @memberof ItemResponseAlertBean
     */
    data: AlertBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAlertBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAlertConfigBean
 */
export interface ItemResponseAlertConfigBean {
    /**
     * 
     * @type {AlertConfigBean}
     * @memberof ItemResponseAlertConfigBean
     */
    data: AlertConfigBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAlertConfigBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseAlertNotificationBean
 */
export interface ItemResponseAlertNotificationBean {
    /**
     * 
     * @type {AlertNotificationBean}
     * @memberof ItemResponseAlertNotificationBean
     */
    data: AlertNotificationBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseAlertNotificationBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCustomFilterBean
 */
export interface ItemResponseCustomFilterBean {
    /**
     * 
     * @type {CustomFilterBean}
     * @memberof ItemResponseCustomFilterBean
     */
    data: CustomFilterBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCustomFilterBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCustomerBean
 */
export interface ItemResponseCustomerBean {
    /**
     * 
     * @type {CustomerBean}
     * @memberof ItemResponseCustomerBean
     */
    data: CustomerBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCustomerBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseCustomersStatBean
 */
export interface ItemResponseCustomersStatBean {
    /**
     * 
     * @type {CustomersStatBean}
     * @memberof ItemResponseCustomersStatBean
     */
    data: CustomersStatBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseCustomersStatBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseManagerBean
 */
export interface ItemResponseManagerBean {
    /**
     * 
     * @type {ManagerBean}
     * @memberof ItemResponseManagerBean
     */
    data: ManagerBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseManagerBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSetupIntentBean
 */
export interface ItemResponseSetupIntentBean {
    /**
     * 
     * @type {SetupIntentBean}
     * @memberof ItemResponseSetupIntentBean
     */
    data: SetupIntentBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSetupIntentBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseSiteInfoBean
 */
export interface ItemResponseSiteInfoBean {
    /**
     * 
     * @type {SiteInfoBean}
     * @memberof ItemResponseSiteInfoBean
     */
    data: SiteInfoBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseSiteInfoBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseString
 */
export interface ItemResponseString {
    /**
     * 
     * @type {string}
     * @memberof ItemResponseString
     */
    data: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseString
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ItemResponseTransactionBean
 */
export interface ItemResponseTransactionBean {
    /**
     * 
     * @type {TransactionBean}
     * @memberof ItemResponseTransactionBean
     */
    data: TransactionBean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ItemResponseTransactionBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface JsonReport
 */
export interface JsonReport {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonReport
     */
    colNames?: Array<string>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof JsonReport
     */
    lines?: Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface JspConfigDescriptor
 */
export interface JspConfigDescriptor {
    /**
     * 
     * @type {Array<TaglibDescriptor>}
     * @memberof JspConfigDescriptor
     */
    taglibs?: Array<TaglibDescriptor>;
    /**
     * 
     * @type {Array<JspPropertyGroupDescriptor>}
     * @memberof JspConfigDescriptor
     */
    jspPropertyGroups?: Array<JspPropertyGroupDescriptor>;
}
/**
 * 
 * @export
 * @interface JspPropertyGroupDescriptor
 */
export interface JspPropertyGroupDescriptor {
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    buffer?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    defaultContentType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JspPropertyGroupDescriptor
     */
    urlPatterns?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    trimDirectiveWhitespaces?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    errorOnELNotFound?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    deferredSyntaxAllowedAsLiteral?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    scriptingInvalid?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    errorOnUndeclaredNamespace?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    isXml?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JspPropertyGroupDescriptor
     */
    includePreludes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    elIgnored?: string;
    /**
     * 
     * @type {string}
     * @memberof JspPropertyGroupDescriptor
     */
    pageEncoding?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JspPropertyGroupDescriptor
     */
    includeCodas?: Array<string>;
}
/**
 * 
 * @export
 * @interface LabelValueBean
 */
export interface LabelValueBean {
    /**
     * 
     * @type {string}
     * @memberof LabelValueBean
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof LabelValueBean
     */
    value: string;
}
/**
 * 
 * @export
 * @interface ListPagination
 */
export interface ListPagination {
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    startPage: number;
    /**
     * 
     * @type {number}
     * @memberof ListPagination
     */
    lastPage: number;
}
/**
 * 
 * @export
 * @interface ListResponseAccountBean
 */
export interface ListResponseAccountBean {
    /**
     * 
     * @type {Array<ItemResponseAccountBean>}
     * @memberof ListResponseAccountBean
     */
    data: Array<ItemResponseAccountBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAccountBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAccountBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAdUnitDictBean
 */
export interface ListResponseAdUnitDictBean {
    /**
     * 
     * @type {Array<ItemResponseAdUnitDictBean>}
     * @memberof ListResponseAdUnitDictBean
     */
    data: Array<ItemResponseAdUnitDictBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdUnitDictBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAdUnitDictBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAdminBean
 */
export interface ListResponseAdminBean {
    /**
     * 
     * @type {Array<ItemResponseAdminBean>}
     * @memberof ListResponseAdminBean
     */
    data: Array<ItemResponseAdminBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAdminBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAdminBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAgencyBean
 */
export interface ListResponseAgencyBean {
    /**
     * 
     * @type {Array<ItemResponseAgencyBean>}
     * @memberof ListResponseAgencyBean
     */
    data: Array<ItemResponseAgencyBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAgencyBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAgencyBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAlertBean
 */
export interface ListResponseAlertBean {
    /**
     * 
     * @type {Array<ItemResponseAlertBean>}
     * @memberof ListResponseAlertBean
     */
    data: Array<ItemResponseAlertBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAlertBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAlertBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAlertConfigBean
 */
export interface ListResponseAlertConfigBean {
    /**
     * 
     * @type {Array<ItemResponseAlertConfigBean>}
     * @memberof ListResponseAlertConfigBean
     */
    data: Array<ItemResponseAlertConfigBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAlertConfigBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAlertConfigBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseAlertNotificationBean
 */
export interface ListResponseAlertNotificationBean {
    /**
     * 
     * @type {Array<ItemResponseAlertNotificationBean>}
     * @memberof ListResponseAlertNotificationBean
     */
    data: Array<ItemResponseAlertNotificationBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseAlertNotificationBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseAlertNotificationBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseCustomFilterBean
 */
export interface ListResponseCustomFilterBean {
    /**
     * 
     * @type {Array<ItemResponseCustomFilterBean>}
     * @memberof ListResponseCustomFilterBean
     */
    data: Array<ItemResponseCustomFilterBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCustomFilterBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseCustomFilterBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseCustomerBean
 */
export interface ListResponseCustomerBean {
    /**
     * 
     * @type {Array<ItemResponseCustomerBean>}
     * @memberof ListResponseCustomerBean
     */
    data: Array<ItemResponseCustomerBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCustomerBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseCustomerBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseCustomersStatBean
 */
export interface ListResponseCustomersStatBean {
    /**
     * 
     * @type {Array<ItemResponseCustomersStatBean>}
     * @memberof ListResponseCustomersStatBean
     */
    data: Array<ItemResponseCustomersStatBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseCustomersStatBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseCustomersStatBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseManagerBean
 */
export interface ListResponseManagerBean {
    /**
     * 
     * @type {Array<ItemResponseManagerBean>}
     * @memberof ListResponseManagerBean
     */
    data: Array<ItemResponseManagerBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseManagerBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseManagerBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseSiteInfoBean
 */
export interface ListResponseSiteInfoBean {
    /**
     * 
     * @type {Array<ItemResponseSiteInfoBean>}
     * @memberof ListResponseSiteInfoBean
     */
    data: Array<ItemResponseSiteInfoBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseSiteInfoBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseSiteInfoBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ListResponseTransactionBean
 */
export interface ListResponseTransactionBean {
    /**
     * 
     * @type {Array<ItemResponseTransactionBean>}
     * @memberof ListResponseTransactionBean
     */
    data: Array<ItemResponseTransactionBean>;
    /**
     * 
     * @type {ListPagination}
     * @memberof ListResponseTransactionBean
     */
    pagination: ListPagination;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ListResponseTransactionBean
     */
    permissions: { [key: string]: boolean; };
}
/**
 * 
 * @export
 * @interface ManagerBean
 */
export interface ManagerBean {
    /**
     * 
     * @type {number}
     * @memberof ManagerBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    managerRole: ManagerBean.ManagerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerBean
     */
    main?: boolean;
}

/**
 * @export
 * @namespace ManagerBean
 */
export namespace ManagerBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ManagerRoleEnum {
        PRIMARY = <any> 'MANAGER_PRIMARY',
        SECONDARY = <any> 'MANAGER_SECONDARY'
    }
}
/**
 * 
 * @export
 * @interface ManagerInfoBean
 */
export interface ManagerInfoBean {
    /**
     * 
     * @type {number}
     * @memberof ManagerInfoBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    managerRole: ManagerInfoBean.ManagerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfoBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerInfoBean
     */
    main?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerInfoBean
     */
    isLoggedIn?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManagerInfoBean
     */
    pageUrlEnabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ManagerInfoBean
     */
    logo?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ManagerInfoBean
     */
    settings?: { [key: string]: any; };
}

/**
 * @export
 * @namespace ManagerInfoBean
 */
export namespace ManagerInfoBean {
    /**
     * @export
     * @enum {string}
     */
    export enum ManagerRoleEnum {
        PRIMARY = <any> 'MANAGER_PRIMARY',
        SECONDARY = <any> 'MANAGER_SECONDARY'
    }
}
/**
 * 
 * @export
 * @interface OverviewChartsData
 */
export interface OverviewChartsData {
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByBidders: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricBySites: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByAdUnits: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByDevices: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByAdSizes: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByCountries: Array<OverviewStatisticsBean>;
    /**
     * 
     * @type {Array<OverviewStatisticsBean>}
     * @memberof OverviewChartsData
     */
    metricByPublishers?: Array<OverviewStatisticsBean>;
}
/**
 * 
 * @export
 * @interface OverviewStatisticsBean
 */
export interface OverviewStatisticsBean {
    /**
     * 
     * @type {string}
     * @memberof OverviewStatisticsBean
     */
    parameterName: string;
    /**
     * 
     * @type {number}
     * @memberof OverviewStatisticsBean
     */
    parameterValue: number;
    /**
     * 
     * @type {number}
     * @memberof OverviewStatisticsBean
     */
    usdParameterValue: number;
    /**
     * 
     * @type {number}
     * @memberof OverviewStatisticsBean
     */
    eurParameterValue: number;
}
/**
 * 
 * @export
 * @interface PageLabelValueBean
 */
export interface PageLabelValueBean {
    /**
     * 
     * @type {number}
     * @memberof PageLabelValueBean
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLabelValueBean
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof PageLabelValueBean
     */
    size?: number;
    /**
     * 
     * @type {Array<LabelValueBean>}
     * @memberof PageLabelValueBean
     */
    content?: Array<LabelValueBean>;
    /**
     * 
     * @type {number}
     * @memberof PageLabelValueBean
     */
    number?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageLabelValueBean
     */
    sort?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageLabelValueBean
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageLabelValueBean
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageLabelValueBean
     */
    numberOfElements?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageLabelValueBean
     */
    pageable?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageLabelValueBean
     */
    empty?: boolean;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    offset?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageableObject
     */
    sort?: SortObject;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageSize?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    unpaged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    paged?: boolean;
}
/**
 * 
 * @export
 * @interface PartnerSiteBean
 */
export interface PartnerSiteBean {
    /**
     * 
     * @type {UIXValueString}
     * @memberof PartnerSiteBean
     */
    name: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof PartnerSiteBean
     */
    domain: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof PartnerSiteBean
     */
    description: UIXValueString;
    /**
     * 
     * @type {number}
     * @memberof PartnerSiteBean
     */
    id: number;
    /**
     * 
     * @type {SiteHealth}
     * @memberof PartnerSiteBean
     */
    siteHealth: SiteHealth;
    /**
     * 
     * @type {string}
     * @memberof PartnerSiteBean
     */
    analyticSetupCode: string;
}
/**
 * 
 * @export
 * @interface PaymentCreateBean
 */
export interface PaymentCreateBean {
    /**
     * 
     * @type {string}
     * @memberof PaymentCreateBean
     */
    accountEmail?: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentCreateBean
     */
    intervalStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentCreateBean
     */
    intervalEnd?: Date;
    /**
     * 
     * @type {number}
     * @memberof PaymentCreateBean
     */
    requests?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentCreateBean
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentCreateBean
     */
    charge?: number;
}
/**
 * 
 * @export
 * @interface PaymentsHistoryBean
 */
export interface PaymentsHistoryBean {
    /**
     * 
     * @type {string}
     * @memberof PaymentsHistoryBean
     */
    billingDate: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentsHistoryBean
     */
    trialEndDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentsHistoryBean
     */
    billingActivated: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentsHistoryBean
     */
    billingProblem?: PaymentsHistoryBean.BillingProblemEnum;
    /**
     * 
     * @type {Array<TransactionBean>}
     * @memberof PaymentsHistoryBean
     */
    transactions: Array<TransactionBean>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentsHistoryBean
     */
    inTrial?: boolean;
}

/**
 * @export
 * @namespace PaymentsHistoryBean
 */
export namespace PaymentsHistoryBean {
    /**
     * @export
     * @enum {string}
     */
    export enum BillingProblemEnum {
        NoRegisteredCard = <any> 'NoRegisteredCard',
        UnexpectedError = <any> 'UnexpectedError',
        CardDeclined = <any> 'CardDeclined',
        AdminBlock = <any> 'AdminBlock',
        DailyImprsExceeded = <any> 'DailyImprsExceeded',
        ClientBlock = <any> 'ClientBlock',
        AuthRequired = <any> 'AuthRequired'
    }
}
/**
 * 
 * @export
 * @interface PeriodQuery
 */
export interface PeriodQuery {
    /**
     * 
     * @type {Date}
     * @memberof PeriodQuery
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PeriodQuery
     */
    endDate: Date;
}
/**
 * 
 * @export
 * @interface ProfileBean
 */
export interface ProfileBean {
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBean
     */
    emailIsConfirmed: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    userCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    uiServerVersion: string;
    /**
     * 
     * @type {HealthMonitorBean}
     * @memberof ProfileBean
     */
    healthMonitorBean: HealthMonitorBean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBean
     */
    billingActivated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBean
     */
    inTrial: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBean
     */
    cardEntered: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileBean
     */
    pageUrlEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    billingProblem?: ProfileBean.BillingProblemEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileBean
     */
    trialEndDate: string;
}

/**
 * @export
 * @namespace ProfileBean
 */
export namespace ProfileBean {
    /**
     * @export
     * @enum {string}
     */
    export enum BillingProblemEnum {
        NoRegisteredCard = <any> 'NoRegisteredCard',
        UnexpectedError = <any> 'UnexpectedError',
        CardDeclined = <any> 'CardDeclined',
        AdminBlock = <any> 'AdminBlock',
        DailyImprsExceeded = <any> 'DailyImprsExceeded',
        ClientBlock = <any> 'ClientBlock',
        AuthRequired = <any> 'AuthRequired'
    }
}
/**
 * 
 * @export
 * @interface ProfileForm
 */
export interface ProfileForm {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileForm
     */
    valid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileForm
     */
    emailIsConfirmed: boolean;
    /**
     * 
     * @type {UIXValueString}
     * @memberof ProfileForm
     */
    firstName: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof ProfileForm
     */
    lastName?: UIXValueString;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    phone?: string;
    /**
     * 
     * @type {UIXValueString}
     * @memberof ProfileForm
     */
    userCurrency: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof ProfileForm
     */
    password: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof ProfileForm
     */
    passwordConfirm: UIXValueString;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileForm
     */
    cardEntered: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    cardTokenId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    cardLast4Digits?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    cardBrand?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileForm
     */
    billingProblem?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    billingErrorMsg?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileForm
     */
    sessionId?: string;
}
/**
 * 
 * @export
 * @interface ProfileResponse
 */
export interface ProfileResponse {
    /**
     * 
     * @type {ProfileForm}
     * @memberof ProfileResponse
     */
    form?: ProfileForm;
}
/**
 * 
 * @export
 * @interface PublisherInfoBean
 */
export interface PublisherInfoBean {
    /**
     * 
     * @type {number}
     * @memberof PublisherInfoBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    role: PublisherInfoBean.RoleEnum;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    passwordConfirm?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherInfoBean
     */
    agencyPageUrlEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherInfoBean
     */
    pageUrlEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublisherInfoBean
     */
    activeSites?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    lastLoginDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    lastTrafficDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    registrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    status?: PublisherInfoBean.StatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PublisherInfoBean
     */
    last30DaysRevenue?: number;
    /**
     * 
     * @type {number}
     * @memberof PublisherInfoBean
     */
    percentToPrevious30Days?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherInfoBean
     */
    accessRights: PublisherInfoBean.AccessRightsEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublisherInfoBean
     */
    isLoggedIn?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublisherInfoBean
     */
    logo?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PublisherInfoBean
     */
    settings?: { [key: string]: any; };
}

/**
 * @export
 * @namespace PublisherInfoBean
 */
export namespace PublisherInfoBean {
    /**
     * @export
     * @enum {string}
     */
    export enum RoleEnum {
        Customer = <any> 'customer',
        TeamOwner = <any> 'team_owner',
        TeamAdmin = <any> 'team_admin',
        TeamMember = <any> 'team_member'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        ACTIVE = <any> 'ACTIVE',
        HOLD = <any> 'HOLD'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AccessRightsEnum {
        FULL = <any> 'FULL',
        READONLY = <any> 'READ_ONLY'
    }
}
/**
 * 
 * @export
 * @interface RedirectView
 */
export interface RedirectView {
    /**
     * 
     * @type {ApplicationContext}
     * @memberof RedirectView
     */
    applicationContext?: ApplicationContext;
    /**
     * 
     * @type {ServletContext}
     * @memberof RedirectView
     */
    servletContext?: ServletContext;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    contentType?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    requestContextAttribute?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RedirectView
     */
    staticAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposePathVariables?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposeContextBeansAsAttributes?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    exposedContextBeanNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    beanName?: string;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    contextRelative?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    http10Compatible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    exposeModelAttributes?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    encodingScheme?: string;
    /**
     * 
     * @type {HttpStatusCode}
     * @memberof RedirectView
     */
    statusCode?: HttpStatusCode;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    expandUriTemplateVariables?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    propagateQueryParams?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RedirectView
     */
    hosts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    redirectView?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedirectView
     */
    propagateQueryProperties?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof RedirectView
     */
    attributes?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof RedirectView
     */
    attributesMap?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof RedirectView
     */
    attributesCSV?: string;
}
/**
 * 
 * @export
 * @interface RegistrationForm
 */
export interface RegistrationForm {
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    email: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    password: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    referralCode: UIXValueString;
    /**
     * 
     * @type {UIXValueBoolean}
     * @memberof RegistrationForm
     */
    needHelp: UIXValueBoolean;
    /**
     * 
     * @type {UIXValueEnumBillingPlan}
     * @memberof RegistrationForm
     */
    billingPlan: UIXValueEnumBillingPlan;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    workspace?: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    crmId?: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RegistrationForm
     */
    name?: UIXValueString;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationForm
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface RegistrationResponse
 */
export interface RegistrationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationResponse
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationResponse
     */
    alreadyRegistered?: boolean;
    /**
     * 
     * @type {RegistrationForm}
     * @memberof RegistrationResponse
     */
    form?: RegistrationForm;
    /**
     * 
     * @type {string}
     * @memberof RegistrationResponse
     */
    domainName?: string;
}
/**
 * 
 * @export
 * @interface RegistrationResponseAdmin
 */
export interface RegistrationResponseAdmin {
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationResponseAdmin
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegistrationResponseAdmin
     */
    alreadyRegistered?: boolean;
    /**
     * 
     * @type {RegistrationForm}
     * @memberof RegistrationResponseAdmin
     */
    form?: RegistrationForm;
    /**
     * 
     * @type {number}
     * @memberof RegistrationResponseAdmin
     */
    accountId?: number;
}
/**
 * 
 * @export
 * @interface ReportFilter
 */
export interface ReportFilter {
    /**
     * 
     * @type {string}
     * @memberof ReportFilter
     */
    column: ReportFilter.ColumnEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportFilter
     */
    values: Array<string>;
}

/**
 * @export
 * @namespace ReportFilter
 */
export namespace ReportFilter {
    /**
     * @export
     * @enum {string}
     */
    export enum ColumnEnum {
        Time = <any> 'time',
        AccountId = <any> 'accountId',
        AccountEmail = <any> 'accountEmail',
        SiteId = <any> 'siteId',
        SiteName = <any> 'siteName',
        SiteKey = <any> 'siteKey',
        Workspace = <any> 'workspace',
        CrmId = <any> 'crmId',
        Day = <any> 'day',
        Hour = <any> 'hour',
        AdUnitCode = <any> 'adUnitCode',
        BidderId = <any> 'bidderId',
        Currency = <any> 'currency',
        MediaType = <any> 'mediaType',
        Size = <any> 'size',
        RequestedSizes = <any> 'requestedSizes',
        BidderResponseTimeBucket = <any> 'bidderResponseTimeBucket',
        Device = <any> 'device',
        Country = <any> 'country',
        UtmSource = <any> 'utmSource',
        UtmMedium = <any> 'utmMedium',
        UtmCampaign = <any> 'utmCampaign',
        UtmTerm = <any> 'utmTerm',
        UtmContent = <any> 'utmContent',
        HbSource = <any> 'hbSource',
        Version = <any> 'version',
        TcfCompliant = <any> 'tcfCompliant',
        SamplingRate = <any> 'samplingRate',
        SamplingValue = <any> 'samplingValue',
        CustomField1 = <any> 'customField1',
        CustomField2 = <any> 'customField2',
        CustomField3 = <any> 'customField3',
        CustomField4 = <any> 'customField4',
        CustomField5 = <any> 'customField5',
        PageUrl = <any> 'pageUrl',
        RefererUrl = <any> 'refererUrl',
        Platform = <any> 'platform',
        Browser = <any> 'browser',
        BidsInAuction = <any> 'bidsInAuction',
        SecondWinBidder = <any> 'secondWinBidder'
    }
}
/**
 * 
 * @export
 * @interface ReportQuery
 */
export interface ReportQuery {
    /**
     * 
     * @type {string}
     * @memberof ReportQuery
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof ReportQuery
     */
    endDate: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportQuery
     */
    keys?: Array<ReportQuery.KeysEnum>;
    /**
     * 
     * @type {Array<ReportFilter>}
     * @memberof ReportQuery
     */
    filters?: Array<ReportFilter>;
    /**
     * 
     * @type {Array<ReportSort>}
     * @memberof ReportQuery
     */
    sorting?: Array<ReportSort>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportQuery
     */
    metrics?: Array<ReportQuery.MetricsEnum>;
}

/**
 * @export
 * @namespace ReportQuery
 */
export namespace ReportQuery {
    /**
     * @export
     * @enum {string}
     */
    export enum KeysEnum {
        Time = <any> 'time',
        AccountId = <any> 'accountId',
        AccountEmail = <any> 'accountEmail',
        SiteId = <any> 'siteId',
        SiteName = <any> 'siteName',
        SiteKey = <any> 'siteKey',
        Workspace = <any> 'workspace',
        CrmId = <any> 'crmId',
        Day = <any> 'day',
        Hour = <any> 'hour',
        AdUnitCode = <any> 'adUnitCode',
        BidderId = <any> 'bidderId',
        Currency = <any> 'currency',
        MediaType = <any> 'mediaType',
        Size = <any> 'size',
        RequestedSizes = <any> 'requestedSizes',
        BidderResponseTimeBucket = <any> 'bidderResponseTimeBucket',
        Device = <any> 'device',
        Country = <any> 'country',
        UtmSource = <any> 'utmSource',
        UtmMedium = <any> 'utmMedium',
        UtmCampaign = <any> 'utmCampaign',
        UtmTerm = <any> 'utmTerm',
        UtmContent = <any> 'utmContent',
        HbSource = <any> 'hbSource',
        Version = <any> 'version',
        TcfCompliant = <any> 'tcfCompliant',
        SamplingRate = <any> 'samplingRate',
        SamplingValue = <any> 'samplingValue',
        CustomField1 = <any> 'customField1',
        CustomField2 = <any> 'customField2',
        CustomField3 = <any> 'customField3',
        CustomField4 = <any> 'customField4',
        CustomField5 = <any> 'customField5',
        PageUrl = <any> 'pageUrl',
        RefererUrl = <any> 'refererUrl',
        Platform = <any> 'platform',
        Browser = <any> 'browser',
        BidsInAuction = <any> 'bidsInAuction',
        SecondWinBidder = <any> 'secondWinBidder'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum MetricsEnum {
        SiteRequests = <any> 'siteRequests',
        AdUnitRequests = <any> 'adUnitRequests',
        Impressions = <any> 'impressions',
        Bids = <any> 'bids',
        Wins = <any> 'wins',
        Timeouts = <any> 'timeouts',
        Auctions = <any> 'auctions',
        BidRequests = <any> 'bidRequests',
        UsdRevenue = <any> 'usdRevenue',
        UsdUnaffectedRevenue = <any> 'usdUnaffectedRevenue',
        UsdEcpm = <any> 'usdEcpm',
        UsdBidPrice = <any> 'usdBidPrice',
        EurRevenue = <any> 'eurRevenue',
        EurUnaffectedRevenue = <any> 'eurUnaffectedRevenue',
        EurEcpm = <any> 'eurEcpm',
        EurBidPrice = <any> 'eurBidPrice',
        Revenue = <any> 'revenue',
        ECPM = <any> 'eCPM',
        BidPrice = <any> 'bidPrice',
        UsdBidPriceSum = <any> 'usdBidPriceSum',
        EurBidPriceSum = <any> 'eurBidPriceSum',
        BidRate = <any> 'bidRate',
        TimeoutRate = <any> 'timeoutRate',
        WinRate = <any> 'winRate',
        AuctionWins = <any> 'auctionWins',
        WinCpmUsd = <any> 'winCpmUsd',
        WinCpmEur = <any> 'winCpmEur',
        SecondWinCpmUsd = <any> 'secondWinCpmUsd',
        SecondWinCpmEur = <any> 'secondWinCpmEur'
    }
}
/**
 * 
 * @export
 * @interface ReportRecords
 */
export interface ReportRecords {
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ReportRecords
     */
    records?: Array<{ [key: string]: any; }>;
}
/**
 * 
 * @export
 * @interface ReportSort
 */
export interface ReportSort {
    /**
     * 
     * @type {string}
     * @memberof ReportSort
     */
    column?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportSort
     */
    order?: ReportSort.OrderEnum;
}

/**
 * @export
 * @namespace ReportSort
 */
export namespace ReportSort {
    /**
     * @export
     * @enum {string}
     */
    export enum OrderEnum {
        Asc = <any> 'asc',
        Desc = <any> 'desc'
    }
}
/**
 * 
 * @export
 * @interface RequestPasswordResetBean
 */
export interface RequestPasswordResetBean {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordResetBean
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordBean
 */
export interface ResetPasswordBean {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBean
     */
    resetToken?: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBean
     */
    newPassword?: string;
}
/**
 * 
 * @export
 * @interface RestorePasswordActionForm
 */
export interface RestorePasswordActionForm {
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordActionForm
     */
    token?: string;
    /**
     * 
     * @type {UIXValueString}
     * @memberof RestorePasswordActionForm
     */
    password: UIXValueString;
    /**
     * 
     * @type {boolean}
     * @memberof RestorePasswordActionForm
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface RestorePasswordActionResponse
 */
export interface RestorePasswordActionResponse {
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordActionResponse
     */
    result?: RestorePasswordActionResponse.ResultEnum;
}

/**
 * @export
 * @namespace RestorePasswordActionResponse
 */
export namespace RestorePasswordActionResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum ResultEnum {
        UnknownToken = <any> 'unknownToken',
        ExpiredToken = <any> 'expiredToken',
        Success = <any> 'success',
        InvalidPassword = <any> 'invalidPassword'
    }
}
/**
 * 
 * @export
 * @interface RestorePasswordRequestForm
 */
export interface RestorePasswordRequestForm {
    /**
     * 
     * @type {UIXValueString}
     * @memberof RestorePasswordRequestForm
     */
    email: UIXValueString;
    /**
     * 
     * @type {boolean}
     * @memberof RestorePasswordRequestForm
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface RestorePasswordRequestResponse
 */
export interface RestorePasswordRequestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RestorePasswordRequestResponse
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RestorePasswordRequestResponse
     */
    alreadyRegistered?: boolean;
    /**
     * 
     * @type {RestorePasswordRequestForm}
     * @memberof RestorePasswordRequestResponse
     */
    form?: RestorePasswordRequestForm;
}
/**
 * 
 * @export
 * @interface ServletContext
 */
export interface ServletContext {
    /**
     * 
     * @type {ApplicationContextClassLoaderParentUnnamedModuleClassLoader}
     * @memberof ServletContext
     */
    classLoader?: ApplicationContextClassLoaderParentUnnamedModuleClassLoader;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    majorVersion?: number;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    minorVersion?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServletContext
     */
    sessionTrackingModes?: Array<ServletContext.SessionTrackingModesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    contextPath?: string;
    /**
     * 
     * @type {any}
     * @memberof ServletContext
     */
    initParameterNames?: any;
    /**
     * 
     * @type {any}
     * @memberof ServletContext
     */
    attributeNames?: any;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    sessionTimeout?: number;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    serverInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    servletContextName?: string;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    effectiveMajorVersion?: number;
    /**
     * 
     * @type {{ [key: string]: FilterRegistration; }}
     * @memberof ServletContext
     */
    filterRegistrations?: { [key: string]: FilterRegistration; };
    /**
     * 
     * @type {SessionCookieConfig}
     * @memberof ServletContext
     */
    sessionCookieConfig?: SessionCookieConfig;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServletContext
     */
    defaultSessionTrackingModes?: Array<ServletContext.DefaultSessionTrackingModesEnum>;
    /**
     * 
     * @type {number}
     * @memberof ServletContext
     */
    effectiveMinorVersion?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServletContext
     */
    effectiveSessionTrackingModes?: Array<ServletContext.EffectiveSessionTrackingModesEnum>;
    /**
     * 
     * @type {{ [key: string]: ServletRegistration; }}
     * @memberof ServletContext
     */
    servletRegistrations?: { [key: string]: ServletRegistration; };
    /**
     * 
     * @type {JspConfigDescriptor}
     * @memberof ServletContext
     */
    jspConfigDescriptor?: JspConfigDescriptor;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    responseCharacterEncoding?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    requestCharacterEncoding?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletContext
     */
    virtualServerName?: string;
}

/**
 * @export
 * @namespace ServletContext
 */
export namespace ServletContext {
    /**
     * @export
     * @enum {string}
     */
    export enum SessionTrackingModesEnum {
        COOKIE = <any> 'COOKIE',
        URL = <any> 'URL',
        SSL = <any> 'SSL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DefaultSessionTrackingModesEnum {
        COOKIE = <any> 'COOKIE',
        URL = <any> 'URL',
        SSL = <any> 'SSL'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum EffectiveSessionTrackingModesEnum {
        COOKIE = <any> 'COOKIE',
        URL = <any> 'URL',
        SSL = <any> 'SSL'
    }
}
/**
 * 
 * @export
 * @interface ServletRegistration
 */
export interface ServletRegistration {
    /**
     * 
     * @type {Array<string>}
     * @memberof ServletRegistration
     */
    mappings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ServletRegistration
     */
    runAsRole?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletRegistration
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ServletRegistration
     */
    className?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ServletRegistration
     */
    initParameters?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface SessionCookieConfig
 */
export interface SessionCookieConfig {
    /**
     * 
     * @type {string}
     * @memberof SessionCookieConfig
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionCookieConfig
     */
    path?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SessionCookieConfig
     */
    attributes?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof SessionCookieConfig
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionCookieConfig
     */
    domain?: string;
    /**
     * 
     * @type {number}
     * @memberof SessionCookieConfig
     */
    maxAge?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SessionCookieConfig
     */
    httpOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionCookieConfig
     */
    secure?: boolean;
}
/**
 * 
 * @export
 * @interface SetupIntentBean
 */
export interface SetupIntentBean {
    /**
     * 
     * @type {string}
     * @memberof SetupIntentBean
     */
    clientSecret?: string;
}
/**
 * 
 * @export
 * @interface SiteBean
 */
export interface SiteBean {
    /**
     * 
     * @type {number}
     * @memberof SiteBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteBean
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SiteHealth
 */
export interface SiteHealth {
    /**
     * 
     * @type {number}
     * @memberof SiteHealth
     */
    trafficHoursAgo?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteHealth
     */
    activeHoursPart?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteHealth
     */
    healthState: SiteHealth.HealthStateEnum;
    /**
     * 
     * @type {BootstrapStatusLabel}
     * @memberof SiteHealth
     */
    healthStatus: BootstrapStatusLabel;
}

/**
 * @export
 * @namespace SiteHealth
 */
export namespace SiteHealth {
    /**
     * @export
     * @enum {string}
     */
    export enum HealthStateEnum {
        Ok = <any> 'ok',
        Normal = <any> 'normal',
        Bad = <any> 'bad',
        NotStarted = <any> 'notStarted'
    }
}
/**
 * 
 * @export
 * @interface SiteInfoBean
 */
export interface SiteInfoBean {
    /**
     * 
     * @type {number}
     * @memberof SiteInfoBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    description?: string;
    /**
     * 
     * @type {SiteHealth}
     * @memberof SiteInfoBean
     */
    siteHealth?: SiteHealth;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    lastStatsTime?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteInfoBean
     */
    analyticCode?: string;
}
/**
 * 
 * @export
 * @interface SitePublicBean
 */
export interface SitePublicBean {
    /**
     * 
     * @type {number}
     * @memberof SitePublicBean
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SitePublicBean
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof SitePublicBean
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SitePublicBean
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof SitePublicBean
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    empty?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    sorted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    unsorted?: boolean;
}
/**
 * 
 * @export
 * @interface StatBlock
 */
export interface StatBlock {
    /**
     * 
     * @type {StatValue}
     * @memberof StatBlock
     */
    summary: StatValue;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof StatBlock
     */
    history: Array<StatValueSnapshot>;
    /**
     * 
     * @type {boolean}
     * @memberof StatBlock
     */
    realData: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatBlock
     */
    maxValue: number;
}
/**
 * 
 * @export
 * @interface StatValue
 */
export interface StatValue {
    /**
     * 
     * @type {number}
     * @memberof StatValue
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof StatValue
     */
    trendValue: number;
    /**
     * 
     * @type {string}
     * @memberof StatValue
     */
    trend: StatValue.TrendEnum;
    /**
     * 
     * @type {number}
     * @memberof StatValue
     */
    trendPercent: number;
    /**
     * 
     * @type {string}
     * @memberof StatValue
     */
    type: StatValue.TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StatValue
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatValue
     */
    realData: boolean;
    /**
     * 
     * @type {number}
     * @memberof StatValue
     */
    roundedValue?: number;
    /**
     * 
     * @type {string}
     * @memberof StatValue
     */
    formattedValue?: string;
    /**
     * 
     * @type {string}
     * @memberof StatValue
     */
    formattedTrendValue?: string;
}

/**
 * @export
 * @namespace StatValue
 */
export namespace StatValue {
    /**
     * @export
     * @enum {string}
     */
    export enum TrendEnum {
        Up = <any> 'up',
        Down = <any> 'down',
        Same = <any> 'same'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Auctions = <any> 'auctions',
        Requests = <any> 'requests',
        BidRequests = <any> 'bidRequests',
        Bids = <any> 'bids',
        Wins = <any> 'wins',
        Impressions = <any> 'impressions',
        Timeouts = <any> 'timeouts',
        UsdECPM = <any> 'usdECPM',
        EurECPM = <any> 'eurECPM',
        UsdRevenue = <any> 'usdRevenue',
        EurRevenue = <any> 'eurRevenue',
        BidRate = <any> 'bidRate',
        WinRate = <any> 'winRate',
        UsdBidPrice = <any> 'usdBidPrice',
        EurBidPrice = <any> 'eurBidPrice',
        TimeoutRate = <any> 'timeoutRate'
    }
}
/**
 * 
 * @export
 * @interface StatValueSnapshot
 */
export interface StatValueSnapshot {
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    value: number;
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    trendValue: number;
    /**
     * 
     * @type {string}
     * @memberof StatValueSnapshot
     */
    trend: StatValueSnapshot.TrendEnum;
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    trendPercent: number;
    /**
     * 
     * @type {string}
     * @memberof StatValueSnapshot
     */
    type: StatValueSnapshot.TypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    position: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatValueSnapshot
     */
    realData: boolean;
    /**
     * 
     * @type {Date}
     * @memberof StatValueSnapshot
     */
    dateTime: Date;
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof StatValueSnapshot
     */
    roundedValue?: number;
    /**
     * 
     * @type {string}
     * @memberof StatValueSnapshot
     */
    formattedValue?: string;
    /**
     * 
     * @type {string}
     * @memberof StatValueSnapshot
     */
    formattedTrendValue?: string;
}

/**
 * @export
 * @namespace StatValueSnapshot
 */
export namespace StatValueSnapshot {
    /**
     * @export
     * @enum {string}
     */
    export enum TrendEnum {
        Up = <any> 'up',
        Down = <any> 'down',
        Same = <any> 'same'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        Auctions = <any> 'auctions',
        Requests = <any> 'requests',
        BidRequests = <any> 'bidRequests',
        Bids = <any> 'bids',
        Wins = <any> 'wins',
        Impressions = <any> 'impressions',
        Timeouts = <any> 'timeouts',
        UsdECPM = <any> 'usdECPM',
        EurECPM = <any> 'eurECPM',
        UsdRevenue = <any> 'usdRevenue',
        EurRevenue = <any> 'eurRevenue',
        BidRate = <any> 'bidRate',
        WinRate = <any> 'winRate',
        UsdBidPrice = <any> 'usdBidPrice',
        EurBidPrice = <any> 'eurBidPrice',
        TimeoutRate = <any> 'timeoutRate'
    }
}
/**
 * 
 * @export
 * @interface Statistics
 */
export interface Statistics {
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    auctions: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    requests: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    bidRequests: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    bids: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    impressions: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    usdECPM: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    eurECPM: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    usdRevenue: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    eurRevenue: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    bidRate: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    winRate: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    usdBidPrice: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    eurBidPrice: StatBlock;
    /**
     * 
     * @type {StatBlock}
     * @memberof Statistics
     */
    timeoutRate: StatBlock;
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof Statistics
     */
    axisX: Array<AxisLabel>;
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof Statistics
     */
    axisYLeft: Array<AxisLabel>;
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof Statistics
     */
    axisYRight: Array<AxisLabel>;
    /**
     * 
     * @type {boolean}
     * @memberof Statistics
     */
    realData: boolean;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    maxCounterValue: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    maxMoneyValue: number;
}
/**
 * 
 * @export
 * @interface TaglibDescriptor
 */
export interface TaglibDescriptor {
    /**
     * 
     * @type {string}
     * @memberof TaglibDescriptor
     */
    taglibURI?: string;
    /**
     * 
     * @type {string}
     * @memberof TaglibDescriptor
     */
    taglibLocation?: string;
}
/**
 * 
 * @export
 * @interface TestDataBean
 */
export interface TestDataBean {
    /**
     * 
     * @type {string}
     * @memberof TestDataBean
     */
    agencyStringId?: string;
    /**
     * 
     * @type {number}
     * @memberof TestDataBean
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof TestDataBean
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof TestDataBean
     */
    days?: number;
}
/**
 * 
 * @export
 * @interface TotalCustomersStatBean
 */
export interface TotalCustomersStatBean {
    /**
     * 
     * @type {number}
     * @memberof TotalCustomersStatBean
     */
    registered: number;
    /**
     * 
     * @type {number}
     * @memberof TotalCustomersStatBean
     */
    confirmed: number;
    /**
     * 
     * @type {number}
     * @memberof TotalCustomersStatBean
     */
    inTrial: number;
    /**
     * 
     * @type {number}
     * @memberof TotalCustomersStatBean
     */
    billingStarted: number;
    /**
     * 
     * @type {number}
     * @memberof TotalCustomersStatBean
     */
    withBillingProblem: number;
}
/**
 * 
 * @export
 * @interface TransactionBean
 */
export interface TransactionBean {
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    paymentDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    billingDate: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    billStartDate: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    billEndDate: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    requests: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    imprs: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    chargeAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    status: TransactionBean.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionBean
     */
    accountEmail: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    attemptsToPay: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionBean
     */
    creatorId?: number;
}

/**
 * @export
 * @namespace TransactionBean
 */
export namespace TransactionBean {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Pending = <any> 'Pending',
        NoBillable = <any> 'No_Billable',
        Paid = <any> 'Paid',
        Failed = <any> 'Failed',
        Paused = <any> 'Paused',
        Declined = <any> 'Declined'
    }
}
/**
 * 
 * @export
 * @interface UIXSettings
 */
export interface UIXSettings {
    /**
     * 
     * @type {UIXSettingsTypes}
     * @memberof UIXSettings
     */
    types: UIXSettingsTypes;
}
/**
 * 
 * @export
 * @interface UIXSettingsTypes
 */
export interface UIXSettingsTypes {
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    registationEmail: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    registationPassword: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    registationReferralCode: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profileFirstName: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profileLastName: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profilePhone: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profileCurrency: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profilePassword: UIXTypeString;
    /**
     * 
     * @type {UIXTypeString}
     * @memberof UIXSettingsTypes
     */
    profilePasswordConfirm: UIXTypeString;
    /**
     * 
     * @type {UIXTypeBoolean}
     * @memberof UIXSettingsTypes
     */
    nativeImageAspectRatioEnabled: UIXTypeBoolean;
    /**
     * 
     * @type {UIXTypeBoolean}
     * @memberof UIXSettingsTypes
     */
    nativeIconAspectRatioEnabled: UIXTypeBoolean;
}
/**
 * 
 * @export
 * @interface UIXTypeBoolean
 */
export interface UIXTypeBoolean {
    /**
     * 
     * @type {string}
     * @memberof UIXTypeBoolean
     */
    type?: UIXTypeBoolean.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeBoolean
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeBoolean
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeBoolean
     */
    requiredError?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeBoolean
     */
    helpId?: UIXTypeBoolean.HelpIdEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeBoolean
     */
    typeahead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeBoolean
     */
    suggestions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeBoolean
     */
    defaultValue: boolean;
}

/**
 * @export
 * @namespace UIXTypeBoolean
 */
export namespace UIXTypeBoolean {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        RegistationEmail = <any> 'registationEmail',
        RegistationPassword = <any> 'registationPassword',
        RegistationReferralCode = <any> 'registationReferralCode'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum HelpIdEnum {
        RegistationEmail = <any> 'registationEmail',
        RegistationPassword = <any> 'registationPassword',
        RegistationReferralCode = <any> 'registationReferralCode'
    }
}
/**
 * 
 * @export
 * @interface UIXTypeString
 */
export interface UIXTypeString {
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    type?: UIXTypeString.TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeString
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    requiredError?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    helpId?: UIXTypeString.HelpIdEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeString
     */
    typeahead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UIXTypeString
     */
    suggestions?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    placeholder?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    leftIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    rightActionLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    regexpValidation?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXTypeString
     */
    regexpValidationError?: string;
}

/**
 * @export
 * @namespace UIXTypeString
 */
export namespace UIXTypeString {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        RegistationEmail = <any> 'registationEmail',
        RegistationPassword = <any> 'registationPassword',
        RegistationReferralCode = <any> 'registationReferralCode'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum HelpIdEnum {
        RegistationEmail = <any> 'registationEmail',
        RegistationPassword = <any> 'registationPassword',
        RegistationReferralCode = <any> 'registationReferralCode'
    }
}
/**
 * 
 * @export
 * @interface UIXValueBoolean
 */
export interface UIXValueBoolean {
    /**
     * 
     * @type {string}
     * @memberof UIXValueBoolean
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueBoolean
     */
    errorLevel?: UIXValueBoolean.ErrorLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UIXValueBoolean
     */
    typeahead?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UIXValueBoolean
     */
    value?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UIXValueBoolean
     */
    error?: string;
}

/**
 * @export
 * @namespace UIXValueBoolean
 */
export namespace UIXValueBoolean {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorLevelEnum {
        Success = <any> 'success',
        Info = <any> 'info',
        Warning = <any> 'warning',
        Danger = <any> 'danger',
        Secondary = <any> 'secondary',
        Primary = <any> 'primary',
        Disabled = <any> 'disabled',
        Error = <any> 'error'
    }
}
/**
 * 
 * @export
 * @interface UIXValueEnumBillingPlan
 */
export interface UIXValueEnumBillingPlan {
    /**
     * 
     * @type {string}
     * @memberof UIXValueEnumBillingPlan
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueEnumBillingPlan
     */
    errorLevel?: UIXValueEnumBillingPlan.ErrorLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UIXValueEnumBillingPlan
     */
    typeahead?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UIXValueEnumBillingPlan
     */
    value?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueEnumBillingPlan
     */
    error?: string;
}

/**
 * @export
 * @namespace UIXValueEnumBillingPlan
 */
export namespace UIXValueEnumBillingPlan {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorLevelEnum {
        Success = <any> 'success',
        Info = <any> 'info',
        Warning = <any> 'warning',
        Danger = <any> 'danger',
        Secondary = <any> 'secondary',
        Primary = <any> 'primary',
        Disabled = <any> 'disabled',
        Error = <any> 'error'
    }
}
/**
 * 
 * @export
 * @interface UIXValueInteger
 */
export interface UIXValueInteger {
    /**
     * 
     * @type {string}
     * @memberof UIXValueInteger
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueInteger
     */
    errorLevel?: UIXValueInteger.ErrorLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UIXValueInteger
     */
    typeahead?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UIXValueInteger
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueInteger
     */
    error?: string;
}

/**
 * @export
 * @namespace UIXValueInteger
 */
export namespace UIXValueInteger {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorLevelEnum {
        Success = <any> 'success',
        Info = <any> 'info',
        Warning = <any> 'warning',
        Danger = <any> 'danger',
        Secondary = <any> 'secondary',
        Primary = <any> 'primary',
        Disabled = <any> 'disabled',
        Error = <any> 'error'
    }
}
/**
 * 
 * @export
 * @interface UIXValueString
 */
export interface UIXValueString {
    /**
     * 
     * @type {string}
     * @memberof UIXValueString
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof UIXValueString
     */
    errorLevel?: UIXValueString.ErrorLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UIXValueString
     */
    typeahead?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UIXValueString
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof UIXValueString
     */
    empty?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UIXValueString
     */
    error?: string;
}

/**
 * @export
 * @namespace UIXValueString
 */
export namespace UIXValueString {
    /**
     * @export
     * @enum {string}
     */
    export enum ErrorLevelEnum {
        Success = <any> 'success',
        Info = <any> 'info',
        Warning = <any> 'warning',
        Danger = <any> 'danger',
        Secondary = <any> 'secondary',
        Primary = <any> 'primary',
        Disabled = <any> 'disabled',
        Error = <any> 'error'
    }
}
/**
 * 
 * @export
 * @interface UTMChartData
 */
export interface UTMChartData {
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    usdRevenueByUTM: Array<UTMStatisticsBean>;
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    eurRevenueByUTM: Array<UTMStatisticsBean>;
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    usdEcpmByUTM: Array<UTMStatisticsBean>;
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    eurEcpmByUTM: Array<UTMStatisticsBean>;
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    winRateByUTM: Array<UTMStatisticsBean>;
    /**
     * 
     * @type {Array<UTMStatisticsBean>}
     * @memberof UTMChartData
     */
    imprsByUTM: Array<UTMStatisticsBean>;
}
/**
 * 
 * @export
 * @interface UTMStatisticsBean
 */
export interface UTMStatisticsBean {
    /**
     * 
     * @type {string}
     * @memberof UTMStatisticsBean
     */
    utmStatisticsParameter: string;
    /**
     * 
     * @type {number}
     * @memberof UTMStatisticsBean
     */
    metricValueByUTM: number;
}
/**
 * 
 * @export
 * @interface UpdateForm
 */
export interface UpdateForm {
    /**
     * 
     * @type {UIXValueString}
     * @memberof UpdateForm
     */
    workspace?: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof UpdateForm
     */
    crmId?: UIXValueString;
    /**
     * 
     * @type {UIXValueString}
     * @memberof UpdateForm
     */
    name?: UIXValueString;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateForm
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateResponseAdmin
 */
export interface UpdateResponseAdmin {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateResponseAdmin
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateResponseAdmin
     */
    emailNotFound?: boolean;
    /**
     * 
     * @type {UpdateForm}
     * @memberof UpdateResponseAdmin
     */
    form?: UpdateForm;
    /**
     * 
     * @type {number}
     * @memberof UpdateResponseAdmin
     */
    accountId?: number;
}
/**
 * 
 * @export
 * @interface VersionChartData
 */
export interface VersionChartData {
    /**
     * 
     * @type {Array<VersionHistoryBean>}
     * @memberof VersionChartData
     */
    versionStats: Array<VersionHistoryBean>;
    /**
     * 
     * @type {Array<AxisLabel>}
     * @memberof VersionChartData
     */
    axisX: Array<AxisLabel>;
}
/**
 * 
 * @export
 * @interface VersionHistoryBean
 */
export interface VersionHistoryBean {
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    bidsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    winsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    impressionsHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    revenueHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    eCPMHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    bidPriceHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    winRateHistory: Array<StatValueSnapshot>;
    /**
     * 
     * @type {string}
     * @memberof VersionHistoryBean
     */
    version: string;
    /**
     * 
     * @type {Array<StatValueSnapshot>}
     * @memberof VersionHistoryBean
     */
    ecpmhistory?: Array<StatValueSnapshot>;
}
/**
 * 
 * @export
 * @interface XYChartData
 */
export interface XYChartData {
    /**
     * 
     * @type {Array<YValues>}
     * @memberof XYChartData
     */
    yvalues?: Array<YValues>;
    /**
     * 
     * @type {Array<string>}
     * @memberof XYChartData
     */
    xlabels?: Array<string>;
}
/**
 * 
 * @export
 * @interface YValues
 */
export interface YValues {
    /**
     * 
     * @type {Array<number>}
     * @memberof YValues
     */
    valuesByX: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof YValues
     */
    ylabel?: string;
}
/**
 * 
 * @export
 * @interface YValuesDouble
 */
export interface YValuesDouble {
    /**
     * 
     * @type {Array<number>}
     * @memberof YValuesDouble
     */
    valuesByX: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof YValuesDouble
     */
    ylabel?: string;
}
/**
 * AccountControllerApi - fetch parameter creator
 * @export
 */
export const AccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo1(options: any = {}): FetchArgs {
            const localVarPath = `/api/account/account-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount1(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccount1.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccount1.');
            }
            const localVarPath = `/api/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters1(options: any = {}): FetchArgs {
            const localVarPath = `/api/account/account/custom-filters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountControllerApi - functional programming interface
 * @export
 */
export const AccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AccountBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).accountInfo1(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount1(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).editAccount1(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomFiltersBean> {
            const localVarFetchArgs = AccountControllerApiFetchParamCreator(configuration).getCustomFilters1(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AccountControllerApi - factory interface
 * @export
 */
export const AccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo1(options?: any) {
            return AccountControllerApiFp(configuration).accountInfo1(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount1(body: AccountBean, id: number, options?: any) {
            return AccountControllerApiFp(configuration).editAccount1(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters1(options?: any) {
            return AccountControllerApiFp(configuration).getCustomFilters1(options)(fetch, basePath);
        },
    };
};

/**
 * AccountControllerApi - object-oriented interface
 * @export
 * @class AccountControllerApi
 * @extends {BaseAPI}
 */
export class AccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public accountInfo1(options?: any) {
        return AccountControllerApiFp(this.configuration).accountInfo1(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public editAccount1(body: AccountBean, id: number, options?: any) {
        return AccountControllerApiFp(this.configuration).editAccount1(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountControllerApi
     */
    public getCustomFilters1(options?: any) {
        return AccountControllerApiFp(this.configuration).getCustomFilters1(options)(this.fetch, this.basePath);
    }

}
/**
 * AdUnitControllerApi - fetch parameter creator
 * @export
 */
export const AdUnitControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitList(options: any = {}): FetchArgs {
            const localVarPath = `/api/adunit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitDictBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdUnit.');
            }
            const localVarPath = `/api/adunit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdUnitDictBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdUnit.');
            }
            const localVarPath = `/api/adunit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnit(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAdUnit.');
            }
            const localVarPath = `/api/adunit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdUnit(body: AdUnitDictBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAdUnit.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAdUnit.');
            }
            const localVarPath = `/api/adunit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdUnitDictBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdUnitControllerApi - functional programming interface
 * @export
 */
export const AdUnitControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdUnitDictBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).adUnitList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitDictBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitDictBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).createAdUnit(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).deleteAdUnit(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnit(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitDictBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).getAdUnit(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdUnit(body: AdUnitDictBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdUnitDictBean> {
            const localVarFetchArgs = AdUnitControllerApiFetchParamCreator(configuration).updateAdUnit(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdUnitControllerApi - factory interface
 * @export
 */
export const AdUnitControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitList(options?: any) {
            return AdUnitControllerApiFp(configuration).adUnitList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdUnit(body: AdUnitDictBean, options?: any) {
            return AdUnitControllerApiFp(configuration).createAdUnit(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdUnit(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).deleteAdUnit(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdUnit(id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).getAdUnit(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdUnitDictBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdUnit(body: AdUnitDictBean, id: number, options?: any) {
            return AdUnitControllerApiFp(configuration).updateAdUnit(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdUnitControllerApi - object-oriented interface
 * @export
 * @class AdUnitControllerApi
 * @extends {BaseAPI}
 */
export class AdUnitControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public adUnitList(options?: any) {
        return AdUnitControllerApiFp(this.configuration).adUnitList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdUnitDictBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public createAdUnit(body: AdUnitDictBean, options?: any) {
        return AdUnitControllerApiFp(this.configuration).createAdUnit(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public deleteAdUnit(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).deleteAdUnit(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public getAdUnit(id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).getAdUnit(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdUnitDictBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdUnitControllerApi
     */
    public updateAdUnit(body: AdUnitDictBean, id: number, options?: any) {
        return AdUnitControllerApiFp(this.configuration).updateAdUnit(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminAccountControllerApi - fetch parameter creator
 * @export
 */
export const AdminAccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account1(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling account1.');
            }
            const localVarPath = `/api/admin/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByAdmin(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling blockStatByAdmin.');
            }
            const localVarPath = `/api/admin/customer/blockStat/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomersSearchQueryBean} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customers(query: CustomersSearchQueryBean, options: any = {}): FetchArgs {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query','Required parameter query was null or undefined when calling customers.');
            }
            const localVarPath = `/api/admin/customers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccount.');
            }
            const localVarPath = `/api/admin/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCustomPayment(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling disableCustomPayment.');
            }
            const localVarPath = `/api/admin/customer/disableCustomPayment/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccount.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccount.');
            }
            const localVarPath = `/api/admin/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCustomPayment(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling enableCustomPayment.');
            }
            const localVarPath = `/api/admin/customer/enableCustomPayment/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAdmin(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAsPublisherByAdmin.');
            }
            const localVarPath = `/api/admin/customer/login-as/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetBillingProblem(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling resetBillingProblem.');
            }
            const localVarPath = `/api/admin/customer/unblockStat/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAccountControllerApi - functional programming interface
 * @export
 */
export const AdminAccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account1(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).account1(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAccountBean> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).accounts(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByAdmin(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).blockStatByAdmin(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CustomersSearchQueryBean} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customers(query: CustomersSearchQueryBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCustomerBean> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).customers(query, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).deleteAccount(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCustomPayment(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).disableCustomPayment(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).editAccount(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCustomPayment(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).enableCustomPayment(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAdmin(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseString> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).loginAsPublisherByAdmin(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetBillingProblem(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAccountControllerApiFetchParamCreator(configuration).resetBillingProblem(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminAccountControllerApi - factory interface
 * @export
 */
export const AdminAccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account1(id: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).account1(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accounts(options?: any) {
            return AdminAccountControllerApiFp(configuration).accounts(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByAdmin(userId: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).blockStatByAdmin(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CustomersSearchQueryBean} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customers(query: CustomersSearchQueryBean, options?: any) {
            return AdminAccountControllerApiFp(configuration).customers(query, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(id: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).deleteAccount(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableCustomPayment(userId: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).disableCustomPayment(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccount(body: AccountBean, id: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).editAccount(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableCustomPayment(userId: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).enableCustomPayment(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAdmin(userId: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).loginAsPublisherByAdmin(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetBillingProblem(userId: number, options?: any) {
            return AdminAccountControllerApiFp(configuration).resetBillingProblem(userId, options)(fetch, basePath);
        },
    };
};

/**
 * AdminAccountControllerApi - object-oriented interface
 * @export
 * @class AdminAccountControllerApi
 * @extends {BaseAPI}
 */
export class AdminAccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public account1(id: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).account1(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public accounts(options?: any) {
        return AdminAccountControllerApiFp(this.configuration).accounts(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public blockStatByAdmin(userId: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).blockStatByAdmin(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CustomersSearchQueryBean} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public customers(query: CustomersSearchQueryBean, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).customers(query, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public deleteAccount(id: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).deleteAccount(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public disableCustomPayment(userId: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).disableCustomPayment(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public editAccount(body: AccountBean, id: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).editAccount(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public enableCustomPayment(userId: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).enableCustomPayment(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public loginAsPublisherByAdmin(userId: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).loginAsPublisherByAdmin(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAccountControllerApi
     */
    public resetBillingProblem(userId: number, options?: any) {
        return AdminAccountControllerApiFp(this.configuration).resetBillingProblem(userId, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminAgencyControllerApi - fetch parameter creator
 * @export
 */
export const AdminAgencyControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency(body: AgencyBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAgency.');
            }
            const localVarPath = `/api/admin/agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAgency.');
            }
            const localVarPath = `/api/admin/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAgency.');
            }
            const localVarPath = `/api/admin/agency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgencies(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsManagerByAdmin(stringId: string, options: any = {}): FetchArgs {
            // verify required parameter 'stringId' is not null or undefined
            if (stringId === null || stringId === undefined) {
                throw new RequiredError('stringId','Required parameter stringId was null or undefined when calling loginAsManagerByAdmin.');
            }
            const localVarPath = `/api/admin/agency/login-as/{stringId}`
                .replace(`{${"stringId"}}`, encodeURIComponent(String(stringId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency(body: AgencyBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAgency.');
            }
            const localVarPath = `/api/admin/agency`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAgencyControllerApi - functional programming interface
 * @export
 */
export const AdminAgencyControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency(body: AgencyBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBean> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).createAgency(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).deleteAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBean> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).getAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgencies(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAgencyBean> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).getAllAgencies(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} stringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsManagerByAdmin(stringId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseString> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).loginAsManagerByAdmin(stringId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency(body: AgencyBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAgencyBean> {
            const localVarFetchArgs = AdminAgencyControllerApiFetchParamCreator(configuration).updateAgency(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminAgencyControllerApi - factory interface
 * @export
 */
export const AdminAgencyControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgency(body: AgencyBean, options?: any) {
            return AdminAgencyControllerApiFp(configuration).createAgency(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgency(id: number, options?: any) {
            return AdminAgencyControllerApiFp(configuration).deleteAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgency(id: number, options?: any) {
            return AdminAgencyControllerApiFp(configuration).getAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAgencies(options?: any) {
            return AdminAgencyControllerApiFp(configuration).getAllAgencies(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} stringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsManagerByAdmin(stringId: string, options?: any) {
            return AdminAgencyControllerApiFp(configuration).loginAsManagerByAdmin(stringId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AgencyBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgency(body: AgencyBean, options?: any) {
            return AdminAgencyControllerApiFp(configuration).updateAgency(body, options)(fetch, basePath);
        },
    };
};

/**
 * AdminAgencyControllerApi - object-oriented interface
 * @export
 * @class AdminAgencyControllerApi
 * @extends {BaseAPI}
 */
export class AdminAgencyControllerApi extends BaseAPI {
    /**
     * 
     * @param {AgencyBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public createAgency(body: AgencyBean, options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).createAgency(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public deleteAgency(id: number, options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).deleteAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public getAgency(id: number, options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).getAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public getAllAgencies(options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).getAllAgencies(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} stringId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public loginAsManagerByAdmin(stringId: string, options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).loginAsManagerByAdmin(stringId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AgencyBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAgencyControllerApi
     */
    public updateAgency(body: AgencyBean, options?: any) {
        return AdminAgencyControllerApiFp(this.configuration).updateAgency(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminControllerApi - fetch parameter creator
 * @export
 */
export const AdminControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/accountInfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admin(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling admin.');
            }
            const localVarPath = `/api/admin/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/admin-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admins(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/admin`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin(body: AdminBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAdmin.');
            }
            const localVarPath = `/api/admin/admin`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdminBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAdmin.');
            }
            const localVarPath = `/api/admin/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(body: AdminBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAdmin.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAdmin.');
            }
            const localVarPath = `/api/admin/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdminBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminControllerApi - functional programming interface
 * @export
 */
export const AdminControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).accountInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admin(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).admin(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).adminInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admins(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).admins(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin(body: AdminBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).createAdmin(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).deleteAdmin(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(body: AdminBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAdminBean> {
            const localVarFetchArgs = AdminControllerApiFetchParamCreator(configuration).editAdmin(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminControllerApi - factory interface
 * @export
 */
export const AdminControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountInfo(options?: any) {
            return AdminControllerApiFp(configuration).accountInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admin(id: number, options?: any) {
            return AdminControllerApiFp(configuration).admin(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminInfo(options?: any) {
            return AdminControllerApiFp(configuration).adminInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        admins(options?: any) {
            return AdminControllerApiFp(configuration).admins(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdmin(body: AdminBean, options?: any) {
            return AdminControllerApiFp(configuration).createAdmin(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdmin(id: number, options?: any) {
            return AdminControllerApiFp(configuration).deleteAdmin(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdminBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(body: AdminBean, id: number, options?: any) {
            return AdminControllerApiFp(configuration).editAdmin(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdminControllerApi - object-oriented interface
 * @export
 * @class AdminControllerApi
 * @extends {BaseAPI}
 */
export class AdminControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public accountInfo(options?: any) {
        return AdminControllerApiFp(this.configuration).accountInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public admin(id: number, options?: any) {
        return AdminControllerApiFp(this.configuration).admin(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public adminInfo(options?: any) {
        return AdminControllerApiFp(this.configuration).adminInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public admins(options?: any) {
        return AdminControllerApiFp(this.configuration).admins(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdminBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public createAdmin(body: AdminBean, options?: any) {
        return AdminControllerApiFp(this.configuration).createAdmin(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public deleteAdmin(id: number, options?: any) {
        return AdminControllerApiFp(this.configuration).deleteAdmin(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdminBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminControllerApi
     */
    public editAdmin(body: AdminBean, id: number, options?: any) {
        return AdminControllerApiFp(this.configuration).editAdmin(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminManagerControllerApi - fetch parameter creator
 * @export
 */
export const AdminManagerControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManagerAdminApi(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteManagerAdminApi.');
            }
            const localVarPath = `/api/admin/manager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagersAdminApi(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagerAdminApi(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getManagerAdminApi.');
            }
            const localVarPath = `/api/admin/manager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManagerAdminApi(body: ManagerBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateManagerAdminApi.');
            }
            const localVarPath = `/api/admin/manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagerBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminManagerControllerApi - functional programming interface
 * @export
 */
export const AdminManagerControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManagerAdminApi(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminManagerControllerApiFetchParamCreator(configuration).deleteManagerAdminApi(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagersAdminApi(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseManagerBean> {
            const localVarFetchArgs = AdminManagerControllerApiFetchParamCreator(configuration).getAllManagersAdminApi(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagerAdminApi(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseManagerBean> {
            const localVarFetchArgs = AdminManagerControllerApiFetchParamCreator(configuration).getManagerAdminApi(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManagerAdminApi(body: ManagerBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseManagerBean> {
            const localVarFetchArgs = AdminManagerControllerApiFetchParamCreator(configuration).updateManagerAdminApi(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminManagerControllerApi - factory interface
 * @export
 */
export const AdminManagerControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManagerAdminApi(id: number, options?: any) {
            return AdminManagerControllerApiFp(configuration).deleteManagerAdminApi(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagersAdminApi(options?: any) {
            return AdminManagerControllerApiFp(configuration).getAllManagersAdminApi(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManagerAdminApi(id: number, options?: any) {
            return AdminManagerControllerApiFp(configuration).getManagerAdminApi(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManagerAdminApi(body: ManagerBean, options?: any) {
            return AdminManagerControllerApiFp(configuration).updateManagerAdminApi(body, options)(fetch, basePath);
        },
    };
};

/**
 * AdminManagerControllerApi - object-oriented interface
 * @export
 * @class AdminManagerControllerApi
 * @extends {BaseAPI}
 */
export class AdminManagerControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagerControllerApi
     */
    public deleteManagerAdminApi(id: number, options?: any) {
        return AdminManagerControllerApiFp(this.configuration).deleteManagerAdminApi(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagerControllerApi
     */
    public getAllManagersAdminApi(options?: any) {
        return AdminManagerControllerApiFp(this.configuration).getAllManagersAdminApi(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagerControllerApi
     */
    public getManagerAdminApi(id: number, options?: any) {
        return AdminManagerControllerApiFp(this.configuration).getManagerAdminApi(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ManagerBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminManagerControllerApi
     */
    public updateManagerAdminApi(body: ManagerBean, options?: any) {
        return AdminManagerControllerApiFp(this.configuration).updateManagerAdminApi(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyAccountControllerApi - fetch parameter creator
 * @export
 */
export const AgencyAccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountByAgency(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAccountByAgency.');
            }
            const localVarPath = `/api/agency/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountByAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAccountByAgency.');
            }
            const localVarPath = `/api/agency/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccountByAgency(body: AccountBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editAccountByAgency.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editAccountByAgency.');
            }
            const localVarPath = `/api/agency/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountByAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAccountByAgency.');
            }
            const localVarPath = `/api/agency/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [status] 
         * @param {string} [sortById] 
         * @param {string} [sortByStatus] 
         * @param {string} [sortByLastLoginDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsPageByAgency(name?: string, email?: string, status?: string, sortById?: string, sortByStatus?: string, sortByLastLoginDate?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/account`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortById !== undefined) {
                localVarQueryParameter['sortById'] = sortById;
            }

            if (sortByStatus !== undefined) {
                localVarQueryParameter['sortByStatus'] = sortByStatus;
            }

            if (sortByLastLoginDate !== undefined) {
                localVarQueryParameter['sortByLastLoginDate'] = sortByLastLoginDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAgency(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAsPublisherByAgency.');
            }
            const localVarPath = `/api/agency/account/login-as/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyAccountControllerApi - functional programming interface
 * @export
 */
export const AgencyAccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountByAgency(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).createAccountByAgency(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountByAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).deleteAccountByAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccountByAgency(body: AccountBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).editAccountByAgency(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountByAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).getAccountByAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [status] 
         * @param {string} [sortById] 
         * @param {string} [sortByStatus] 
         * @param {string} [sortByLastLoginDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsPageByAgency(name?: string, email?: string, status?: string, sortById?: string, sortByStatus?: string, sortByLastLoginDate?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAccountBean> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).getAccountsPageByAgency(name, email, status, sortById, sortByStatus, sortByLastLoginDate, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAgency(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseString> {
            const localVarFetchArgs = AgencyAccountControllerApiFetchParamCreator(configuration).loginAsPublisherByAgency(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyAccountControllerApi - factory interface
 * @export
 */
export const AgencyAccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountByAgency(body: AccountBean, options?: any) {
            return AgencyAccountControllerApiFp(configuration).createAccountByAgency(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountByAgency(id: number, options?: any) {
            return AgencyAccountControllerApiFp(configuration).deleteAccountByAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AccountBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAccountByAgency(body: AccountBean, id: number, options?: any) {
            return AgencyAccountControllerApiFp(configuration).editAccountByAgency(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountByAgency(id: number, options?: any) {
            return AgencyAccountControllerApiFp(configuration).getAccountByAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [status] 
         * @param {string} [sortById] 
         * @param {string} [sortByStatus] 
         * @param {string} [sortByLastLoginDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsPageByAgency(name?: string, email?: string, status?: string, sortById?: string, sortByStatus?: string, sortByLastLoginDate?: string, options?: any) {
            return AgencyAccountControllerApiFp(configuration).getAccountsPageByAgency(name, email, status, sortById, sortByStatus, sortByLastLoginDate, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsPublisherByAgency(userId: number, options?: any) {
            return AgencyAccountControllerApiFp(configuration).loginAsPublisherByAgency(userId, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyAccountControllerApi - object-oriented interface
 * @export
 * @class AgencyAccountControllerApi
 * @extends {BaseAPI}
 */
export class AgencyAccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public createAccountByAgency(body: AccountBean, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).createAccountByAgency(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public deleteAccountByAgency(id: number, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).deleteAccountByAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AccountBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public editAccountByAgency(body: AccountBean, id: number, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).editAccountByAgency(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public getAccountByAgency(id: number, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).getAccountByAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [email] 
     * @param {string} [status] 
     * @param {string} [sortById] 
     * @param {string} [sortByStatus] 
     * @param {string} [sortByLastLoginDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public getAccountsPageByAgency(name?: string, email?: string, status?: string, sortById?: string, sortByStatus?: string, sortByLastLoginDate?: string, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).getAccountsPageByAgency(name, email, status, sortById, sortByStatus, sortByLastLoginDate, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyAccountControllerApi
     */
    public loginAsPublisherByAgency(userId: number, options?: any) {
        return AgencyAccountControllerApiFp(this.configuration).loginAsPublisherByAgency(userId, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyCustomFilterControllerApi - fetch parameter creator
 * @export
 */
export const AgencyCustomFilterControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomFilterByAgency(body: CustomFilterBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createCustomFilterByAgency.');
            }
            const localVarPath = `/api/agency/custom-filter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CustomFilterBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomFilterByAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteCustomFilterByAgency.');
            }
            const localVarPath = `/api/agency/custom-filter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCustomFilterByAgency(body: CustomFilterBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling editCustomFilterByAgency.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editCustomFilterByAgency.');
            }
            const localVarPath = `/api/agency/custom-filter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CustomFilterBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomFiltersByAgency(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/custom-filter`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilterByAgency(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCustomFilterByAgency.');
            }
            const localVarPath = `/api/agency/custom-filter/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFiltersPageByAgency(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/custom-filter/page`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyCustomFilterControllerApi - functional programming interface
 * @export
 */
export const AgencyCustomFilterControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomFilterByAgency(body: CustomFilterBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCustomFilterBean> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).createCustomFilterByAgency(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomFilterByAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).deleteCustomFilterByAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCustomFilterByAgency(body: CustomFilterBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCustomFilterBean> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).editCustomFilterByAgency(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomFiltersByAgency(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCustomFilterBean> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).getAllCustomFiltersByAgency(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilterByAgency(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseCustomFilterBean> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).getCustomFilterByAgency(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFiltersPageByAgency(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCustomFilterBean> {
            const localVarFetchArgs = AgencyCustomFilterControllerApiFetchParamCreator(configuration).getCustomFiltersPageByAgency(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyCustomFilterControllerApi - factory interface
 * @export
 */
export const AgencyCustomFilterControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomFilterByAgency(body: CustomFilterBean, options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).createCustomFilterByAgency(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomFilterByAgency(id: number, options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).deleteCustomFilterByAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CustomFilterBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCustomFilterByAgency(body: CustomFilterBean, id: number, options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).editCustomFilterByAgency(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomFiltersByAgency(options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).getAllCustomFiltersByAgency(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilterByAgency(id: number, options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).getCustomFilterByAgency(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFiltersPageByAgency(options?: any) {
            return AgencyCustomFilterControllerApiFp(configuration).getCustomFiltersPageByAgency(options)(fetch, basePath);
        },
    };
};

/**
 * AgencyCustomFilterControllerApi - object-oriented interface
 * @export
 * @class AgencyCustomFilterControllerApi
 * @extends {BaseAPI}
 */
export class AgencyCustomFilterControllerApi extends BaseAPI {
    /**
     * 
     * @param {CustomFilterBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public createCustomFilterByAgency(body: CustomFilterBean, options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).createCustomFilterByAgency(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public deleteCustomFilterByAgency(id: number, options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).deleteCustomFilterByAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CustomFilterBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public editCustomFilterByAgency(body: CustomFilterBean, id: number, options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).editCustomFilterByAgency(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public getAllCustomFiltersByAgency(options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).getAllCustomFiltersByAgency(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public getCustomFilterByAgency(id: number, options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).getCustomFilterByAgency(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomFilterControllerApi
     */
    public getCustomFiltersPageByAgency(options?: any) {
        return AgencyCustomFilterControllerApiFp(this.configuration).getCustomFiltersPageByAgency(options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyCustomizationControllerApi - fetch parameter creator
 * @export
 */
export const AgencyCustomizationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/custom/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling uploadCustomSettings.');
            }
            const localVarPath = `/api/agency/custom/settings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"{ [key: string]: any; }" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} [logo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(logo?: Blob, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/custom/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new url.URLSearchParams();

            if (logo !== undefined) {
                localVarFormParams.set('logo', logo as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyCustomizationControllerApi - functional programming interface
 * @export
 */
export const AgencyCustomizationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyCustomizationControllerApiFetchParamCreator(configuration).deleteLogo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyCustomizationControllerApiFetchParamCreator(configuration).uploadCustomSettings(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} [logo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(logo?: Blob, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyCustomizationControllerApiFetchParamCreator(configuration).uploadLogo(logo, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyCustomizationControllerApi - factory interface
 * @export
 */
export const AgencyCustomizationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLogo(options?: any) {
            return AgencyCustomizationControllerApiFp(configuration).deleteLogo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {{ [key: string]: any; }} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCustomSettings(body: { [key: string]: any; }, options?: any) {
            return AgencyCustomizationControllerApiFp(configuration).uploadCustomSettings(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} [logo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLogo(logo?: Blob, options?: any) {
            return AgencyCustomizationControllerApiFp(configuration).uploadLogo(logo, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyCustomizationControllerApi - object-oriented interface
 * @export
 * @class AgencyCustomizationControllerApi
 * @extends {BaseAPI}
 */
export class AgencyCustomizationControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomizationControllerApi
     */
    public deleteLogo(options?: any) {
        return AgencyCustomizationControllerApiFp(this.configuration).deleteLogo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {{ [key: string]: any; }} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomizationControllerApi
     */
    public uploadCustomSettings(body: { [key: string]: any; }, options?: any) {
        return AgencyCustomizationControllerApiFp(this.configuration).uploadCustomSettings(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} [logo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyCustomizationControllerApi
     */
    public uploadLogo(logo?: Blob, options?: any) {
        return AgencyCustomizationControllerApiFp(this.configuration).uploadLogo(logo, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyManagerControllerApi - fetch parameter creator
 * @export
 */
export const AgencyManagerControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManager(body: ManagerBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createManager.');
            }
            const localVarPath = `/api/agency/manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagerBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManager(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteManager.');
            }
            const localVarPath = `/api/agency/manager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagers(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManager(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getManager.');
            }
            const localVarPath = `/api/agency/manager/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManager(body: ManagerBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateManager.');
            }
            const localVarPath = `/api/agency/manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagerBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyManagerControllerApi - functional programming interface
 * @export
 */
export const AgencyManagerControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManager(body: ManagerBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseManagerBean> {
            const localVarFetchArgs = AgencyManagerControllerApiFetchParamCreator(configuration).createManager(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManager(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyManagerControllerApiFetchParamCreator(configuration).deleteManager(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseManagerBean> {
            const localVarFetchArgs = AgencyManagerControllerApiFetchParamCreator(configuration).getAllManagers(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManager(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseManagerBean> {
            const localVarFetchArgs = AgencyManagerControllerApiFetchParamCreator(configuration).getManager(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManager(body: ManagerBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseManagerBean> {
            const localVarFetchArgs = AgencyManagerControllerApiFetchParamCreator(configuration).updateManager(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyManagerControllerApi - factory interface
 * @export
 */
export const AgencyManagerControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManager(body: ManagerBean, options?: any) {
            return AgencyManagerControllerApiFp(configuration).createManager(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManager(id: number, options?: any) {
            return AgencyManagerControllerApiFp(configuration).deleteManager(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllManagers(options?: any) {
            return AgencyManagerControllerApiFp(configuration).getAllManagers(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManager(id: number, options?: any) {
            return AgencyManagerControllerApiFp(configuration).getManager(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ManagerBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateManager(body: ManagerBean, options?: any) {
            return AgencyManagerControllerApiFp(configuration).updateManager(body, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyManagerControllerApi - object-oriented interface
 * @export
 * @class AgencyManagerControllerApi
 * @extends {BaseAPI}
 */
export class AgencyManagerControllerApi extends BaseAPI {
    /**
     * 
     * @param {ManagerBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyManagerControllerApi
     */
    public createManager(body: ManagerBean, options?: any) {
        return AgencyManagerControllerApiFp(this.configuration).createManager(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyManagerControllerApi
     */
    public deleteManager(id: number, options?: any) {
        return AgencyManagerControllerApiFp(this.configuration).deleteManager(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyManagerControllerApi
     */
    public getAllManagers(options?: any) {
        return AgencyManagerControllerApiFp(this.configuration).getAllManagers(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyManagerControllerApi
     */
    public getManager(id: number, options?: any) {
        return AgencyManagerControllerApiFp(this.configuration).getManager(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ManagerBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyManagerControllerApi
     */
    public updateManager(body: ManagerBean, options?: any) {
        return AgencyManagerControllerApiFp(this.configuration).updateManager(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyPreferencesControllerApi - fetch parameter creator
 * @export
 */
export const AgencyPreferencesControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/preferences/get`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AgencyPreferences} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(body: AgencyPreferences, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateSettings.');
            }
            const localVarPath = `/api/agency/preferences/update`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AgencyPreferences" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyPreferencesControllerApi - functional programming interface
 * @export
 */
export const AgencyPreferencesControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AgencyPreferences> {
            const localVarFetchArgs = AgencyPreferencesControllerApiFetchParamCreator(configuration).getSettings(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AgencyPreferences} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(body: AgencyPreferences, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyPreferencesControllerApiFetchParamCreator(configuration).updateSettings(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyPreferencesControllerApi - factory interface
 * @export
 */
export const AgencyPreferencesControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettings(options?: any) {
            return AgencyPreferencesControllerApiFp(configuration).getSettings(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AgencyPreferences} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSettings(body: AgencyPreferences, options?: any) {
            return AgencyPreferencesControllerApiFp(configuration).updateSettings(body, options)(fetch, basePath);
        },
    };
};

/**
 * AgencyPreferencesControllerApi - object-oriented interface
 * @export
 * @class AgencyPreferencesControllerApi
 * @extends {BaseAPI}
 */
export class AgencyPreferencesControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyPreferencesControllerApi
     */
    public getSettings(options?: any) {
        return AgencyPreferencesControllerApiFp(this.configuration).getSettings(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AgencyPreferences} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyPreferencesControllerApi
     */
    public updateSettings(body: AgencyPreferences, options?: any) {
        return AgencyPreferencesControllerApiFp(this.configuration).updateSettings(body, options)(this.fetch, this.basePath);
    }

}
/**
 * AgencyReportControllerApi - fetch parameter creator
 * @export
 */
export const AgencyReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAgencyReport(body: ReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling downloadAgencyReport.');
            }
            const localVarPath = `/api/agency/report/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyAdUnitValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/ad-unit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyBidderValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/bidder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyCustomFilters(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/custom`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySiteValues(search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/site`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySizeValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/size`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyVersionValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAgencyJsonReport(body: ReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAgencyJsonReport.');
            }
            const localVarPath = `/api/agency/report/json`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportKeys(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/keys`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportMetrics(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/report/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyReportControllerApi - functional programming interface
 * @export
 */
export const AgencyReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAgencyReport(body: ReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).downloadAgencyReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyAdUnitValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencyAdUnitValues(siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyBidderValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencyBidderValues(siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyCustomFilters(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CustomFilterBean>> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencyCustomFilters(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySiteValues(search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencySiteValues(search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySizeValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencySizeValues(siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyVersionValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).filteredAgencyVersionValues(siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAgencyJsonReport(body: ReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportRecords> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).generateAgencyJsonReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportKeys(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FilterBean>> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).getAgencyReportKeys(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportMetrics(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FilterBean>> {
            const localVarFetchArgs = AgencyReportControllerApiFetchParamCreator(configuration).getAgencyReportMetrics(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AgencyReportControllerApi - factory interface
 * @export
 */
export const AgencyReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAgencyReport(body: ReportQuery, options?: any) {
            return AgencyReportControllerApiFp(configuration).downloadAgencyReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyAdUnitValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencyAdUnitValues(siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyBidderValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencyBidderValues(siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyCustomFilters(options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencyCustomFilters(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySiteValues(search?: string, page?: number, count?: number, options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencySiteValues(search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencySizeValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencySizeValues(siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAgencyVersionValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return AgencyReportControllerApiFp(configuration).filteredAgencyVersionValues(siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAgencyJsonReport(body: ReportQuery, options?: any) {
            return AgencyReportControllerApiFp(configuration).generateAgencyJsonReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportKeys(options?: any) {
            return AgencyReportControllerApiFp(configuration).getAgencyReportKeys(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgencyReportMetrics(options?: any) {
            return AgencyReportControllerApiFp(configuration).getAgencyReportMetrics(options)(fetch, basePath);
        },
    };
};

/**
 * AgencyReportControllerApi - object-oriented interface
 * @export
 * @class AgencyReportControllerApi
 * @extends {BaseAPI}
 */
export class AgencyReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {ReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public downloadAgencyReport(body: ReportQuery, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).downloadAgencyReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencyAdUnitValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencyAdUnitValues(siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencyBidderValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencyBidderValues(siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencyCustomFilters(options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencyCustomFilters(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencySiteValues(search?: string, page?: number, count?: number, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencySiteValues(search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencySizeValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencySizeValues(siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public filteredAgencyVersionValues(siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).filteredAgencyVersionValues(siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public generateAgencyJsonReport(body: ReportQuery, options?: any) {
        return AgencyReportControllerApiFp(this.configuration).generateAgencyJsonReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public getAgencyReportKeys(options?: any) {
        return AgencyReportControllerApiFp(this.configuration).getAgencyReportKeys(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyReportControllerApi
     */
    public getAgencyReportMetrics(options?: any) {
        return AgencyReportControllerApiFp(this.configuration).getAgencyReportMetrics(options)(this.fetch, this.basePath);
    }

}
/**
 * AlertConfigControllerApi - fetch parameter creator
 * @export
 */
export const AlertConfigControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertConfig(body: AlertConfigBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAlertConfig.');
            }
            const localVarPath = `/api/alert-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertConfigBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertConfig(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAlertConfig.');
            }
            const localVarPath = `/api/alert-config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfig(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAlertConfig.');
            }
            const localVarPath = `/api/alert-config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfigList(options: any = {}): FetchArgs {
            const localVarPath = `/api/alert-config`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlertConfig(options: any = {}): FetchArgs {
            const localVarPath = `/api/alert-config/configs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/alert-config/info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertConfig(body: AlertConfigBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAlertConfig.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAlertConfig.');
            }
            const localVarPath = `/api/alert-config/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertConfigBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertConfigControllerApi - functional programming interface
 * @export
 */
export const AlertConfigControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertConfig(body: AlertConfigBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertConfigBean> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).createAlertConfig(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertConfig(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).deleteAlertConfig(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfig(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertConfigBean> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).getAlertConfig(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfigList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAlertConfigBean> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).getAlertConfigList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlertConfig(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AlertConfigBean>> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).getAllAlertConfig(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).getInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertConfig(body: AlertConfigBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertConfigBean> {
            const localVarFetchArgs = AlertConfigControllerApiFetchParamCreator(configuration).updateAlertConfig(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AlertConfigControllerApi - factory interface
 * @export
 */
export const AlertConfigControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertConfig(body: AlertConfigBean, options?: any) {
            return AlertConfigControllerApiFp(configuration).createAlertConfig(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertConfig(id: number, options?: any) {
            return AlertConfigControllerApiFp(configuration).deleteAlertConfig(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfig(id: number, options?: any) {
            return AlertConfigControllerApiFp(configuration).getAlertConfig(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertConfigList(options?: any) {
            return AlertConfigControllerApiFp(configuration).getAlertConfigList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAlertConfig(options?: any) {
            return AlertConfigControllerApiFp(configuration).getAllAlertConfig(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options?: any) {
            return AlertConfigControllerApiFp(configuration).getInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AlertConfigBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertConfig(body: AlertConfigBean, id: number, options?: any) {
            return AlertConfigControllerApiFp(configuration).updateAlertConfig(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AlertConfigControllerApi - object-oriented interface
 * @export
 * @class AlertConfigControllerApi
 * @extends {BaseAPI}
 */
export class AlertConfigControllerApi extends BaseAPI {
    /**
     * 
     * @param {AlertConfigBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public createAlertConfig(body: AlertConfigBean, options?: any) {
        return AlertConfigControllerApiFp(this.configuration).createAlertConfig(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public deleteAlertConfig(id: number, options?: any) {
        return AlertConfigControllerApiFp(this.configuration).deleteAlertConfig(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public getAlertConfig(id: number, options?: any) {
        return AlertConfigControllerApiFp(this.configuration).getAlertConfig(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public getAlertConfigList(options?: any) {
        return AlertConfigControllerApiFp(this.configuration).getAlertConfigList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public getAllAlertConfig(options?: any) {
        return AlertConfigControllerApiFp(this.configuration).getAllAlertConfig(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public getInfo(options?: any) {
        return AlertConfigControllerApiFp(this.configuration).getInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AlertConfigBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertConfigControllerApi
     */
    public updateAlertConfig(body: AlertConfigBean, id: number, options?: any) {
        return AlertConfigControllerApiFp(this.configuration).updateAlertConfig(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AlertControllerApi - fetch parameter creator
 * @export
 */
export const AlertControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PeriodQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertList(body: PeriodQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling alertList.');
            }
            const localVarPath = `/api/alert/alert-list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PeriodQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlert(body: AlertBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAlert.');
            }
            const localVarPath = `/api/alert`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAlert.');
            }
            const localVarPath = `/api/alert/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlert(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAlert.');
            }
            const localVarPath = `/api/alert/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewAlertsCount(options: any = {}): FetchArgs {
            const localVarPath = `/api/alert/new-count`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlert(body: AlertBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAlert.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAlert.');
            }
            const localVarPath = `/api/alert/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertControllerApi - functional programming interface
 * @export
 */
export const AlertControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PeriodQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertList(body: PeriodQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAlertBean> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).alertList(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlert(body: AlertBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertBean> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).createAlert(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).deleteAlert(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlert(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertBean> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).getAlert(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewAlertsCount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).getNewAlertsCount(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlert(body: AlertBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertBean> {
            const localVarFetchArgs = AlertControllerApiFetchParamCreator(configuration).updateAlert(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AlertControllerApi - factory interface
 * @export
 */
export const AlertControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {PeriodQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertList(body: PeriodQuery, options?: any) {
            return AlertControllerApiFp(configuration).alertList(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlert(body: AlertBean, options?: any) {
            return AlertControllerApiFp(configuration).createAlert(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlert(id: number, options?: any) {
            return AlertControllerApiFp(configuration).deleteAlert(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlert(id: number, options?: any) {
            return AlertControllerApiFp(configuration).getAlert(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewAlertsCount(options?: any) {
            return AlertControllerApiFp(configuration).getNewAlertsCount(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AlertBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlert(body: AlertBean, id: number, options?: any) {
            return AlertControllerApiFp(configuration).updateAlert(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AlertControllerApi - object-oriented interface
 * @export
 * @class AlertControllerApi
 * @extends {BaseAPI}
 */
export class AlertControllerApi extends BaseAPI {
    /**
     * 
     * @param {PeriodQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public alertList(body: PeriodQuery, options?: any) {
        return AlertControllerApiFp(this.configuration).alertList(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AlertBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public createAlert(body: AlertBean, options?: any) {
        return AlertControllerApiFp(this.configuration).createAlert(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public deleteAlert(id: number, options?: any) {
        return AlertControllerApiFp(this.configuration).deleteAlert(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getAlert(id: number, options?: any) {
        return AlertControllerApiFp(this.configuration).getAlert(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public getNewAlertsCount(options?: any) {
        return AlertControllerApiFp(this.configuration).getNewAlertsCount(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AlertBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertControllerApi
     */
    public updateAlert(body: AlertBean, id: number, options?: any) {
        return AlertControllerApiFp(this.configuration).updateAlert(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AlertNotificationControllerApi - fetch parameter creator
 * @export
 */
export const AlertNotificationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertNotification(body: AlertNotificationBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAlertNotification.');
            }
            const localVarPath = `/api/alert-notification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertNotificationBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertNotification(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAlertNotification.');
            }
            const localVarPath = `/api/alert-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotification(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getAlertNotification.');
            }
            const localVarPath = `/api/alert-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotificationList(options: any = {}): FetchArgs {
            const localVarPath = `/api/alert-notification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertNotification(body: AlertNotificationBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateAlertNotification.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateAlertNotification.');
            }
            const localVarPath = `/api/alert-notification/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AlertNotificationBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlertNotificationControllerApi - functional programming interface
 * @export
 */
export const AlertNotificationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertNotification(body: AlertNotificationBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertNotificationBean> {
            const localVarFetchArgs = AlertNotificationControllerApiFetchParamCreator(configuration).createAlertNotification(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertNotification(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AlertNotificationControllerApiFetchParamCreator(configuration).deleteAlertNotification(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotification(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertNotificationBean> {
            const localVarFetchArgs = AlertNotificationControllerApiFetchParamCreator(configuration).getAlertNotification(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotificationList(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseAlertNotificationBean> {
            const localVarFetchArgs = AlertNotificationControllerApiFetchParamCreator(configuration).getAlertNotificationList(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertNotification(body: AlertNotificationBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAlertNotificationBean> {
            const localVarFetchArgs = AlertNotificationControllerApiFetchParamCreator(configuration).updateAlertNotification(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AlertNotificationControllerApi - factory interface
 * @export
 */
export const AlertNotificationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAlertNotification(body: AlertNotificationBean, options?: any) {
            return AlertNotificationControllerApiFp(configuration).createAlertNotification(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAlertNotification(id: number, options?: any) {
            return AlertNotificationControllerApiFp(configuration).deleteAlertNotification(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotification(id: number, options?: any) {
            return AlertNotificationControllerApiFp(configuration).getAlertNotification(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlertNotificationList(options?: any) {
            return AlertNotificationControllerApiFp(configuration).getAlertNotificationList(options)(fetch, basePath);
        },
        /**
         * 
         * @param {AlertNotificationBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAlertNotification(body: AlertNotificationBean, id: number, options?: any) {
            return AlertNotificationControllerApiFp(configuration).updateAlertNotification(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AlertNotificationControllerApi - object-oriented interface
 * @export
 * @class AlertNotificationControllerApi
 * @extends {BaseAPI}
 */
export class AlertNotificationControllerApi extends BaseAPI {
    /**
     * 
     * @param {AlertNotificationBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertNotificationControllerApi
     */
    public createAlertNotification(body: AlertNotificationBean, options?: any) {
        return AlertNotificationControllerApiFp(this.configuration).createAlertNotification(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertNotificationControllerApi
     */
    public deleteAlertNotification(id: number, options?: any) {
        return AlertNotificationControllerApiFp(this.configuration).deleteAlertNotification(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertNotificationControllerApi
     */
    public getAlertNotification(id: number, options?: any) {
        return AlertNotificationControllerApiFp(this.configuration).getAlertNotification(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertNotificationControllerApi
     */
    public getAlertNotificationList(options?: any) {
        return AlertNotificationControllerApiFp(this.configuration).getAlertNotificationList(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AlertNotificationBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertNotificationControllerApi
     */
    public updateAlertNotification(body: AlertNotificationBean, id: number, options?: any) {
        return AlertNotificationControllerApiFp(this.configuration).updateAlertNotification(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * BillingControllerApi - fetch parameter creator
 * @export
 */
export const BillingControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePayments(date: string, options: any = {}): FetchArgs {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling calculatePayments.');
            }
            const localVarPath = `/billing/calcPayments`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        charge(date: string, options: any = {}): FetchArgs {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling charge.');
            }
            const localVarPath = `/billing/charge`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBillingStart(accountId: string, date: string, options: any = {}): FetchArgs {
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling setBillingStart.');
            }
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling setBillingStart.');
            }
            const localVarPath = `/billing/setBillingStart`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialCheck(date: string, options: any = {}): FetchArgs {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling trialCheck.');
            }
            const localVarPath = `/billing/trial-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningTrialCheck(date: string, options: any = {}): FetchArgs {
            // verify required parameter 'date' is not null or undefined
            if (date === null || date === undefined) {
                throw new RequiredError('date','Required parameter date was null or undefined when calling warningTrialCheck.');
            }
            const localVarPath = `/billing/warning-trial-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BillingControllerApi - functional programming interface
 * @export
 */
export const BillingControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePayments(date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BillingControllerApiFetchParamCreator(configuration).calculatePayments(date, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        charge(date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BillingControllerApiFetchParamCreator(configuration).charge(date, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBillingStart(accountId: string, date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BillingControllerApiFetchParamCreator(configuration).setBillingStart(accountId, date, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialCheck(date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BillingControllerApiFetchParamCreator(configuration).trialCheck(date, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningTrialCheck(date: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BillingControllerApiFetchParamCreator(configuration).warningTrialCheck(date, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BillingControllerApi - factory interface
 * @export
 */
export const BillingControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePayments(date: string, options?: any) {
            return BillingControllerApiFp(configuration).calculatePayments(date, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        charge(date: string, options?: any) {
            return BillingControllerApiFp(configuration).charge(date, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} accountId 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBillingStart(accountId: string, date: string, options?: any) {
            return BillingControllerApiFp(configuration).setBillingStart(accountId, date, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialCheck(date: string, options?: any) {
            return BillingControllerApiFp(configuration).trialCheck(date, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        warningTrialCheck(date: string, options?: any) {
            return BillingControllerApiFp(configuration).warningTrialCheck(date, options)(fetch, basePath);
        },
    };
};

/**
 * BillingControllerApi - object-oriented interface
 * @export
 * @class BillingControllerApi
 * @extends {BaseAPI}
 */
export class BillingControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingControllerApi
     */
    public calculatePayments(date: string, options?: any) {
        return BillingControllerApiFp(this.configuration).calculatePayments(date, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingControllerApi
     */
    public charge(date: string, options?: any) {
        return BillingControllerApiFp(this.configuration).charge(date, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} accountId 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingControllerApi
     */
    public setBillingStart(accountId: string, date: string, options?: any) {
        return BillingControllerApiFp(this.configuration).setBillingStart(accountId, date, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingControllerApi
     */
    public trialCheck(date: string, options?: any) {
        return BillingControllerApiFp(this.configuration).trialCheck(date, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} date 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingControllerApi
     */
    public warningTrialCheck(date: string, options?: any) {
        return BillingControllerApiFp(this.configuration).warningTrialCheck(date, options)(this.fetch, this.basePath);
    }

}
/**
 * BuildInfoControllerApi - fetch parameter creator
 * @export
 */
export const BuildInfoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options: any = {}): FetchArgs {
            const localVarPath = `/build-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfoPrometheus(options: any = {}): FetchArgs {
            const localVarPath = `/build-info/prometheus`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuildInfoControllerApi - functional programming interface
 * @export
 */
export const BuildInfoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<{ [key: string]: any; }> {
            const localVarFetchArgs = BuildInfoControllerApiFetchParamCreator(configuration).buildInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfoPrometheus(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = BuildInfoControllerApiFetchParamCreator(configuration).buildInfoPrometheus(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BuildInfoControllerApi - factory interface
 * @export
 */
export const BuildInfoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfo(options?: any) {
            return BuildInfoControllerApiFp(configuration).buildInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildInfoPrometheus(options?: any) {
            return BuildInfoControllerApiFp(configuration).buildInfoPrometheus(options)(fetch, basePath);
        },
    };
};

/**
 * BuildInfoControllerApi - object-oriented interface
 * @export
 * @class BuildInfoControllerApi
 * @extends {BaseAPI}
 */
export class BuildInfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildInfoControllerApi
     */
    public buildInfo(options?: any) {
        return BuildInfoControllerApiFp(this.configuration).buildInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuildInfoControllerApi
     */
    public buildInfoPrometheus(options?: any) {
        return BuildInfoControllerApiFp(this.configuration).buildInfoPrometheus(options)(this.fetch, this.basePath);
    }

}
/**
 * ChangeLogControllerApi - fetch parameter creator
 * @export
 */
export const ChangeLogControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changelogid(type: string, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling changelogid.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changelogid.');
            }
            const localVarPath = `/api/changelog/changelogid`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangeLogControllerApi - functional programming interface
 * @export
 */
export const ChangeLogControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changelogid(type: string, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = ChangeLogControllerApiFetchParamCreator(configuration).changelogid(type, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ChangeLogControllerApi - factory interface
 * @export
 */
export const ChangeLogControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} type 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changelogid(type: string, id: number, options?: any) {
            return ChangeLogControllerApiFp(configuration).changelogid(type, id, options)(fetch, basePath);
        },
    };
};

/**
 * ChangeLogControllerApi - object-oriented interface
 * @export
 * @class ChangeLogControllerApi
 * @extends {BaseAPI}
 */
export class ChangeLogControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} type 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangeLogControllerApi
     */
    public changelogid(type: string, id: number, options?: any) {
        return ChangeLogControllerApiFp(this.configuration).changelogid(type, id, options)(this.fetch, this.basePath);
    }

}
/**
 * CustomersStatControllerApi - fetch parameter creator
 * @export
 */
export const CustomersStatControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomersStatQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newCustomersStat(body: CustomersStatQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling newCustomersStat.');
            }
            const localVarPath = `/api/admin/newCustomersStat`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CustomersStatQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalCustomersStat(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/totalCustomersStat`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersStatControllerApi - functional programming interface
 * @export
 */
export const CustomersStatControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomersStatQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newCustomersStat(body: CustomersStatQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseCustomersStatBean> {
            const localVarFetchArgs = CustomersStatControllerApiFetchParamCreator(configuration).newCustomersStat(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalCustomersStat(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TotalCustomersStatBean> {
            const localVarFetchArgs = CustomersStatControllerApiFetchParamCreator(configuration).totalCustomersStat(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CustomersStatControllerApi - factory interface
 * @export
 */
export const CustomersStatControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CustomersStatQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newCustomersStat(body: CustomersStatQuery, options?: any) {
            return CustomersStatControllerApiFp(configuration).newCustomersStat(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        totalCustomersStat(options?: any) {
            return CustomersStatControllerApiFp(configuration).totalCustomersStat(options)(fetch, basePath);
        },
    };
};

/**
 * CustomersStatControllerApi - object-oriented interface
 * @export
 * @class CustomersStatControllerApi
 * @extends {BaseAPI}
 */
export class CustomersStatControllerApi extends BaseAPI {
    /**
     * 
     * @param {CustomersStatQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersStatControllerApi
     */
    public newCustomersStat(body: CustomersStatQuery, options?: any) {
        return CustomersStatControllerApiFp(this.configuration).newCustomersStat(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersStatControllerApi
     */
    public totalCustomersStat(options?: any) {
        return CustomersStatControllerApiFp(this.configuration).totalCustomersStat(options)(this.fetch, this.basePath);
    }

}
/**
 * DemoAccessControllerApi - fetch parameter creator
 * @export
 */
export const DemoAccessControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {{ [key: string]: string; }} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsDemo(key: string, params: { [key: string]: string; }, options: any = {}): FetchArgs {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling loginAsDemo.');
            }
            // verify required parameter 'params' is not null or undefined
            if (params === null || params === undefined) {
                throw new RequiredError('params','Required parameter params was null or undefined when calling loginAsDemo.');
            }
            const localVarPath = `/demo/access/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (params !== undefined) {
                localVarQueryParameter['params'] = params;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemoAccessControllerApi - functional programming interface
 * @export
 */
export const DemoAccessControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {{ [key: string]: string; }} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsDemo(key: string, params: { [key: string]: string; }, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RedirectView> {
            const localVarFetchArgs = DemoAccessControllerApiFetchParamCreator(configuration).loginAsDemo(key, params, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DemoAccessControllerApi - factory interface
 * @export
 */
export const DemoAccessControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {{ [key: string]: string; }} params 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAsDemo(key: string, params: { [key: string]: string; }, options?: any) {
            return DemoAccessControllerApiFp(configuration).loginAsDemo(key, params, options)(fetch, basePath);
        },
    };
};

/**
 * DemoAccessControllerApi - object-oriented interface
 * @export
 * @class DemoAccessControllerApi
 * @extends {BaseAPI}
 */
export class DemoAccessControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} key 
     * @param {{ [key: string]: string; }} params 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoAccessControllerApi
     */
    public loginAsDemo(key: string, params: { [key: string]: string; }, options?: any) {
        return DemoAccessControllerApiFp(this.configuration).loginAsDemo(key, params, options)(this.fetch, this.basePath);
    }

}
/**
 * DomainControllerApi - fetch parameter creator
 * @export
 */
export const DomainControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainsForValidBundles(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/create-domains-for-valid-bundles`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DomainControllerApi - functional programming interface
 * @export
 */
export const DomainControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainsForValidBundles(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DomainControllerApiFetchParamCreator(configuration).createDomainsForValidBundles(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DomainControllerApi - factory interface
 * @export
 */
export const DomainControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDomainsForValidBundles(options?: any) {
            return DomainControllerApiFp(configuration).createDomainsForValidBundles(options)(fetch, basePath);
        },
    };
};

/**
 * DomainControllerApi - object-oriented interface
 * @export
 * @class DomainControllerApi
 * @extends {BaseAPI}
 */
export class DomainControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DomainControllerApi
     */
    public createDomainsForValidBundles(options?: any) {
        return DomainControllerApiFp(this.configuration).createDomainsForValidBundles(options)(this.fetch, this.basePath);
    }

}
/**
 * HealthControllerApi - fetch parameter creator
 * @export
 */
export const HealthControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeReady(options: any = {}): FetchArgs {
            const localVarPath = `/mt/ready`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeUnready(options: any = {}): FetchArgs {
            const localVarPath = `/mt/unready`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthControllerApi - functional programming interface
 * @export
 */
export const HealthControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeReady(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = HealthControllerApiFetchParamCreator(configuration).makeReady(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeUnready(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = HealthControllerApiFetchParamCreator(configuration).makeUnready(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * HealthControllerApi - factory interface
 * @export
 */
export const HealthControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeReady(options?: any) {
            return HealthControllerApiFp(configuration).makeReady(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeUnready(options?: any) {
            return HealthControllerApiFp(configuration).makeUnready(options)(fetch, basePath);
        },
    };
};

/**
 * HealthControllerApi - object-oriented interface
 * @export
 * @class HealthControllerApi
 * @extends {BaseAPI}
 */
export class HealthControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthControllerApi
     */
    public makeReady(options?: any) {
        return HealthControllerApiFp(this.configuration).makeReady(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthControllerApi
     */
    public makeUnready(options?: any) {
        return HealthControllerApiFp(this.configuration).makeUnready(options)(this.fetch, this.basePath);
    }

}
/**
 * InfoControllerApi - fetch parameter creator
 * @export
 */
export const InfoControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerIsLoggedIn(options: any = {}): FetchArgs {
            const localVarPath = `/api/agency/manager-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherIsLoggedIn(options: any = {}): FetchArgs {
            const localVarPath = `/api/publisher/publisher-info`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoControllerApi - functional programming interface
 * @export
 */
export const InfoControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerIsLoggedIn(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagerInfoBean> {
            const localVarFetchArgs = InfoControllerApiFetchParamCreator(configuration).managerIsLoggedIn(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherIsLoggedIn(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PublisherInfoBean> {
            const localVarFetchArgs = InfoControllerApiFetchParamCreator(configuration).publisherIsLoggedIn(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InfoControllerApi - factory interface
 * @export
 */
export const InfoControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerIsLoggedIn(options?: any) {
            return InfoControllerApiFp(configuration).managerIsLoggedIn(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publisherIsLoggedIn(options?: any) {
            return InfoControllerApiFp(configuration).publisherIsLoggedIn(options)(fetch, basePath);
        },
    };
};

/**
 * InfoControllerApi - object-oriented interface
 * @export
 * @class InfoControllerApi
 * @extends {BaseAPI}
 */
export class InfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public managerIsLoggedIn(options?: any) {
        return InfoControllerApiFp(this.configuration).managerIsLoggedIn(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public publisherIsLoggedIn(options?: any) {
        return InfoControllerApiFp(this.configuration).publisherIsLoggedIn(options)(this.fetch, this.basePath);
    }

}
/**
 * PartnerAccountControllerApi - fetch parameter creator
 * @export
 */
export const PartnerAccountControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite1(accountId: number, bundleId: number, options: any = {}): FetchArgs {
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling archiveSite1.');
            }
            // verify required parameter 'bundleId' is not null or undefined
            if (bundleId === null || bundleId === undefined) {
                throw new RequiredError('bundleId','Required parameter bundleId was null or undefined when calling archiveSite1.');
            }
            const localVarPath = `/api/partner/archive/{accountId}/{bundleId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)))
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: RegistrationForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPublisher.');
            }
            const localVarPath = `/api/partner/account/register`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RegistrationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BundleCreateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite1(body: BundleCreateForm, accountId: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSite1.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling createSite1.');
            }
            const localVarPath = `/api/partner/account/createSite/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BundleCreateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(accountId: number, options: any = {}): FetchArgs {
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling deletePublisher.');
            }
            const localVarPath = `/api/partner/account/delete/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters(options: any = {}): FetchArgs {
            const localVarPath = `/api/partner/account/custom-filters`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling loginAs.');
            }
            const localVarPath = `/api/partner/customer/login-as/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisher(body: UpdateForm, accountId: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePublisher.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling updatePublisher.');
            }
            const localVarPath = `/api/partner/account/update/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerAccountControllerApi - functional programming interface
 * @export
 */
export const PartnerAccountControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite1(accountId: number, bundleId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).archiveSite1(accountId, bundleId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: RegistrationForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RegistrationResponseAdmin> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).createPublisher(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BundleCreateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite1(body: BundleCreateForm, accountId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BundleCreateResponseAdmin> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).createSite1(body, accountId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(accountId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).deletePublisher(accountId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomFiltersBean> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).getCustomFilters(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseString> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).loginAs(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisher(body: UpdateForm, accountId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UpdateResponseAdmin> {
            const localVarFetchArgs = PartnerAccountControllerApiFetchParamCreator(configuration).updatePublisher(body, accountId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PartnerAccountControllerApi - factory interface
 * @export
 */
export const PartnerAccountControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} accountId 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite1(accountId: number, bundleId: number, options?: any) {
            return PartnerAccountControllerApiFp(configuration).archiveSite1(accountId, bundleId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPublisher(body: RegistrationForm, options?: any) {
            return PartnerAccountControllerApiFp(configuration).createPublisher(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BundleCreateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite1(body: BundleCreateForm, accountId: number, options?: any) {
            return PartnerAccountControllerApiFp(configuration).createSite1(body, accountId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePublisher(accountId: number, options?: any) {
            return PartnerAccountControllerApiFp(configuration).deletePublisher(accountId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomFilters(options?: any) {
            return PartnerAccountControllerApiFp(configuration).getCustomFilters(options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginAs(userId: number, options?: any) {
            return PartnerAccountControllerApiFp(configuration).loginAs(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateForm} body 
         * @param {number} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisher(body: UpdateForm, accountId: number, options?: any) {
            return PartnerAccountControllerApiFp(configuration).updatePublisher(body, accountId, options)(fetch, basePath);
        },
    };
};

/**
 * PartnerAccountControllerApi - object-oriented interface
 * @export
 * @class PartnerAccountControllerApi
 * @extends {BaseAPI}
 */
export class PartnerAccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} accountId 
     * @param {number} bundleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public archiveSite1(accountId: number, bundleId: number, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).archiveSite1(accountId, bundleId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RegistrationForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public createPublisher(body: RegistrationForm, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).createPublisher(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BundleCreateForm} body 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public createSite1(body: BundleCreateForm, accountId: number, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).createSite1(body, accountId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public deletePublisher(accountId: number, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).deletePublisher(accountId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public getCustomFilters(options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).getCustomFilters(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public loginAs(userId: number, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).loginAs(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateForm} body 
     * @param {number} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerAccountControllerApi
     */
    public updatePublisher(body: UpdateForm, accountId: number, options?: any) {
        return PartnerAccountControllerApiFp(this.configuration).updatePublisher(body, accountId, options)(this.fetch, this.basePath);
    }

}
/**
 * PartnerSiteControllerApi - fetch parameter creator
 * @export
 */
export const PartnerSiteControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteForPartner(bundleId: number, options: any = {}): FetchArgs {
            // verify required parameter 'bundleId' is not null or undefined
            if (bundleId === null || bundleId === undefined) {
                throw new RequiredError('bundleId','Required parameter bundleId was null or undefined when calling getSiteForPartner.');
            }
            const localVarPath = `/api/partner/site/getSite/{bundleId}`
                .replace(`{${"bundleId"}}`, encodeURIComponent(String(bundleId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerSiteControllerApi - functional programming interface
 * @export
 */
export const PartnerSiteControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteForPartner(bundleId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PartnerSiteBean> {
            const localVarFetchArgs = PartnerSiteControllerApiFetchParamCreator(configuration).getSiteForPartner(bundleId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PartnerSiteControllerApi - factory interface
 * @export
 */
export const PartnerSiteControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} bundleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteForPartner(bundleId: number, options?: any) {
            return PartnerSiteControllerApiFp(configuration).getSiteForPartner(bundleId, options)(fetch, basePath);
        },
    };
};

/**
 * PartnerSiteControllerApi - object-oriented interface
 * @export
 * @class PartnerSiteControllerApi
 * @extends {BaseAPI}
 */
export class PartnerSiteControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} bundleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerSiteControllerApi
     */
    public getSiteForPartner(bundleId: number, options?: any) {
        return PartnerSiteControllerApiFp(this.configuration).getSiteForPartner(bundleId, options)(this.fetch, this.basePath);
    }

}
/**
 * PartnerStatControllerApi - fetch parameter creator
 * @export
 */
export const PartnerStatControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype1(body: FieldChartQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adtype1.');
            }
            const localVarPath = `/api/partner/stat/adtype`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FieldChartQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard1(body: DashboardQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling dashboard1.');
            }
            const localVarPath = `/api/partner/stat/dashboard`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReportOld(body: BasicReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling downloadAuctionsReportOld.');
            }
            const localVarPath = `/api/partner/stat/download/report/auctions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BasicReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportOld(body: BasicReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAuctionsJsonReportOld.');
            }
            const localVarPath = `/api/partner/stat/generate/report/auctions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BasicReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart1(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBidderFunnelChart1.');
            }
            const localVarPath = `/api/partner/stat/bidders/funnel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime1(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBiddersMetricsByTime1.');
            }
            const localVarPath = `/api/partner/stat/bidders/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart1(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBiddersResponseTimeChart1.');
            }
            const localVarPath = `/api/partner/stat/bidders/responseTime`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart1(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadIncrementalRevenueChart1.');
            }
            const localVarPath = `/api/partner/stat/bidders/incrementalRevenue`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart1(body: DashboardQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadOverviewChart1.');
            }
            const localVarPath = `/api/partner/stat/dashboard/overview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version1(body: FieldChartQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling version1.');
            }
            const localVarPath = `/api/partner/stat/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FieldChartQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerStatControllerApi - functional programming interface
 * @export
 */
export const PartnerStatControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype1(body: FieldChartQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdTypeChartData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).adtype1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard1(body: DashboardQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DashboardBean> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).dashboard1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReportOld(body: BasicReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).downloadAuctionsReportOld(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportOld(body: BasicReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JsonReport> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).generateAuctionsJsonReportOld(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart1(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FunnelChartData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).loadBidderFunnelChart1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime1(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BiddersMetricByTime> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).loadBiddersMetricsByTime1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart1(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<XYChartData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).loadBiddersResponseTimeChart1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart1(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<IncrementalRevenueChartData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).loadIncrementalRevenueChart1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart1(body: DashboardQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OverviewChartsData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).loadOverviewChart1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version1(body: FieldChartQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VersionChartData> {
            const localVarFetchArgs = PartnerStatControllerApiFetchParamCreator(configuration).version1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PartnerStatControllerApi - factory interface
 * @export
 */
export const PartnerStatControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype1(body: FieldChartQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).adtype1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard1(body: DashboardQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).dashboard1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReportOld(body: BasicReportQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).downloadAuctionsReportOld(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportOld(body: BasicReportQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).generateAuctionsJsonReportOld(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart1(body: BidderMetricsQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).loadBidderFunnelChart1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime1(body: BidderMetricsQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).loadBiddersMetricsByTime1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart1(body: BidderMetricsQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).loadBiddersResponseTimeChart1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart1(body: BidderMetricsQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).loadIncrementalRevenueChart1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart1(body: DashboardQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).loadOverviewChart1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version1(body: FieldChartQuery, options?: any) {
            return PartnerStatControllerApiFp(configuration).version1(body, options)(fetch, basePath);
        },
    };
};

/**
 * PartnerStatControllerApi - object-oriented interface
 * @export
 * @class PartnerStatControllerApi
 * @extends {BaseAPI}
 */
export class PartnerStatControllerApi extends BaseAPI {
    /**
     * 
     * @param {FieldChartQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public adtype1(body: FieldChartQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).adtype1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public dashboard1(body: DashboardQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).dashboard1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BasicReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public downloadAuctionsReportOld(body: BasicReportQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).downloadAuctionsReportOld(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BasicReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public generateAuctionsJsonReportOld(body: BasicReportQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).generateAuctionsJsonReportOld(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public loadBidderFunnelChart1(body: BidderMetricsQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).loadBidderFunnelChart1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public loadBiddersMetricsByTime1(body: BidderMetricsQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).loadBiddersMetricsByTime1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public loadBiddersResponseTimeChart1(body: BidderMetricsQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).loadBiddersResponseTimeChart1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public loadIncrementalRevenueChart1(body: BidderMetricsQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).loadIncrementalRevenueChart1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public loadOverviewChart1(body: DashboardQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).loadOverviewChart1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {FieldChartQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnerStatControllerApi
     */
    public version1(body: FieldChartQuery, options?: any) {
        return PartnerStatControllerApiFp(this.configuration).version1(body, options)(this.fetch, this.basePath);
    }

}
/**
 * PaymentControllerApi - fetch parameter creator
 * @export
 */
export const PaymentControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment(paymentIntentId: string, options: any = {}): FetchArgs {
            // verify required parameter 'paymentIntentId' is not null or undefined
            if (paymentIntentId === null || paymentIntentId === undefined) {
                throw new RequiredError('paymentIntentId','Required parameter paymentIntentId was null or undefined when calling confirmPayment.');
            }
            const localVarPath = `/api/payment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paymentIntentId !== undefined) {
                localVarQueryParameter['paymentIntentId'] = paymentIntentId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentControllerApi - functional programming interface
 * @export
 */
export const PaymentControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment(paymentIntentId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PaymentControllerApiFetchParamCreator(configuration).confirmPayment(paymentIntentId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PaymentControllerApi - factory interface
 * @export
 */
export const PaymentControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} paymentIntentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmPayment(paymentIntentId: string, options?: any) {
            return PaymentControllerApiFp(configuration).confirmPayment(paymentIntentId, options)(fetch, basePath);
        },
    };
};

/**
 * PaymentControllerApi - object-oriented interface
 * @export
 * @class PaymentControllerApi
 * @extends {BaseAPI}
 */
export class PaymentControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} paymentIntentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentControllerApi
     */
    public confirmPayment(paymentIntentId: string, options?: any) {
        return PaymentControllerApiFp(this.configuration).confirmPayment(paymentIntentId, options)(this.fetch, this.basePath);
    }

}
/**
 * PaymentMethodControllerApi - fetch parameter creator
 * @export
 */
export const PaymentMethodControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerSession(options: any = {}): FetchArgs {
            const localVarPath = `/api/payment-method/create-customer-session`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSetupIntent(options: any = {}): FetchArgs {
            const localVarPath = `/api/payment-method/create-setup-intent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentMethodControllerApi - functional programming interface
 * @export
 */
export const PaymentMethodControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerSession(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSetupIntentBean> {
            const localVarFetchArgs = PaymentMethodControllerApiFetchParamCreator(configuration).createCustomerSession(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSetupIntent(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseSetupIntentBean> {
            const localVarFetchArgs = PaymentMethodControllerApiFetchParamCreator(configuration).createSetupIntent(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PaymentMethodControllerApi - factory interface
 * @export
 */
export const PaymentMethodControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerSession(options?: any) {
            return PaymentMethodControllerApiFp(configuration).createCustomerSession(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSetupIntent(options?: any) {
            return PaymentMethodControllerApiFp(configuration).createSetupIntent(options)(fetch, basePath);
        },
    };
};

/**
 * PaymentMethodControllerApi - object-oriented interface
 * @export
 * @class PaymentMethodControllerApi
 * @extends {BaseAPI}
 */
export class PaymentMethodControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodControllerApi
     */
    public createCustomerSession(options?: any) {
        return PaymentMethodControllerApiFp(this.configuration).createCustomerSession(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentMethodControllerApi
     */
    public createSetupIntent(options?: any) {
        return PaymentMethodControllerApiFp(this.configuration).createSetupIntent(options)(this.fetch, this.basePath);
    }

}
/**
 * PaymentsControllerApi - fetch parameter creator
 * @export
 */
export const PaymentsControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PaymentCreateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: PaymentCreateBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling create.');
            }
            const localVarPath = `/api/admin`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PaymentCreateBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declinePayment(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling declinePayment.');
            }
            const localVarPath = `/api/admin/payment/decline/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [statuses] 
         * @param {string} [email] 
         * @param {boolean} [createdByAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByAdmin(statuses?: Array<string>, email?: string, createdByAdmin?: boolean, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/payments`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (createdByAdmin !== undefined) {
                localVarQueryParameter['createdByAdmin'] = createdByAdmin;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pausePayment(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling pausePayment.');
            }
            const localVarPath = `/api/admin/payment/pause/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unPausePayment(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling unPausePayment.');
            }
            const localVarPath = `/api/admin/payment/unpause/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsControllerApi - functional programming interface
 * @export
 */
export const PaymentsControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PaymentCreateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: PaymentCreateBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = PaymentsControllerApiFetchParamCreator(configuration).create(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declinePayment(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PaymentsControllerApiFetchParamCreator(configuration).declinePayment(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Array<string>} [statuses] 
         * @param {string} [email] 
         * @param {boolean} [createdByAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByAdmin(statuses?: Array<string>, email?: string, createdByAdmin?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseTransactionBean> {
            const localVarFetchArgs = PaymentsControllerApiFetchParamCreator(configuration).getPaymentsByAdmin(statuses, email, createdByAdmin, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pausePayment(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PaymentsControllerApiFetchParamCreator(configuration).pausePayment(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unPausePayment(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PaymentsControllerApiFetchParamCreator(configuration).unPausePayment(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PaymentsControllerApi - factory interface
 * @export
 */
export const PaymentsControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {PaymentCreateBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body: PaymentCreateBean, options?: any) {
            return PaymentsControllerApiFp(configuration).create(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declinePayment(id: number, options?: any) {
            return PaymentsControllerApiFp(configuration).declinePayment(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Array<string>} [statuses] 
         * @param {string} [email] 
         * @param {boolean} [createdByAdmin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentsByAdmin(statuses?: Array<string>, email?: string, createdByAdmin?: boolean, options?: any) {
            return PaymentsControllerApiFp(configuration).getPaymentsByAdmin(statuses, email, createdByAdmin, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pausePayment(id: number, options?: any) {
            return PaymentsControllerApiFp(configuration).pausePayment(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unPausePayment(id: number, options?: any) {
            return PaymentsControllerApiFp(configuration).unPausePayment(id, options)(fetch, basePath);
        },
    };
};

/**
 * PaymentsControllerApi - object-oriented interface
 * @export
 * @class PaymentsControllerApi
 * @extends {BaseAPI}
 */
export class PaymentsControllerApi extends BaseAPI {
    /**
     * 
     * @param {PaymentCreateBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    public create(body: PaymentCreateBean, options?: any) {
        return PaymentsControllerApiFp(this.configuration).create(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    public declinePayment(id: number, options?: any) {
        return PaymentsControllerApiFp(this.configuration).declinePayment(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [statuses] 
     * @param {string} [email] 
     * @param {boolean} [createdByAdmin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    public getPaymentsByAdmin(statuses?: Array<string>, email?: string, createdByAdmin?: boolean, options?: any) {
        return PaymentsControllerApiFp(this.configuration).getPaymentsByAdmin(statuses, email, createdByAdmin, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    public pausePayment(id: number, options?: any) {
        return PaymentsControllerApiFp(this.configuration).pausePayment(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsControllerApi
     */
    public unPausePayment(id: number, options?: any) {
        return PaymentsControllerApiFp(this.configuration).unPausePayment(id, options)(this.fetch, this.basePath);
    }

}
/**
 * ProfileControllerApi - fetch parameter creator
 * @export
 */
export const ProfileControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(options: any = {}): FetchArgs {
            const localVarPath = `/api/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientBlockBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByClient(body: ClientBlockBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling blockStatByClient.');
            }
            const localVarPath = `/api/profile/blockStatByClient`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ClientBlockBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(bean: ChangePasswordBean, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling changePassword.');
            }
            const localVarPath = `/api/changePassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForEdit(options: any = {}): FetchArgs {
            const localVarPath = `/api/profile/edit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payments(options: any = {}): FetchArgs {
            const localVarPath = `/api/payments`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailConfirmationEmail(options: any = {}): FetchArgs {
            const localVarPath = `/api/requestEmailConfirmation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RequestPasswordResetBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(bean: RequestPasswordResetBean, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling requestPasswordReset.');
            }
            const localVarPath = `/api/requestPasswordReset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset1(bean: ResetPasswordBean, options: any = {}): FetchArgs {
            // verify required parameter 'bean' is not null or undefined
            if (bean === null || bean === undefined) {
                throw new RequiredError('bean','Required parameter bean was null or undefined when calling requestPasswordReset1.');
            }
            const localVarPath = `/api/passwordReset`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bean !== undefined) {
                localVarQueryParameter['bean'] = bean;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationEmail(options: any = {}): FetchArgs {
            const localVarPath = `/api/profile/resendConfirmationEmail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ContactSupportForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactSupportRequest(body: ContactSupportForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendContactSupportRequest.');
            }
            const localVarPath = `/api/support`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ContactSupportForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uix(options: any = {}): FetchArgs {
            const localVarPath = `/api/uix`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfileForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ProfileForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling update.');
            }
            const localVarPath = `/api/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfileForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileControllerApi - functional programming interface
 * @export
 */
export const ProfileControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfileBean> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).account(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ClientBlockBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByClient(body: ClientBlockBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).blockStatByClient(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ChangePasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(bean: ChangePasswordBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).changePassword(bean, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForEdit(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfileResponse> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).getForEdit(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payments(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PaymentsHistoryBean> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).payments(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailConfirmationEmail(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).requestEmailConfirmationEmail(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RequestPasswordResetBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(bean: RequestPasswordResetBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).requestPasswordReset(bean, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ResetPasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset1(bean: ResetPasswordBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).requestPasswordReset1(bean, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationEmail(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).resendConfirmationEmail(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ContactSupportForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactSupportRequest(body: ContactSupportForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).sendContactSupportRequest(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uix(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UIXSettings> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).uix(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ProfileForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ProfileForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProfileResponse> {
            const localVarFetchArgs = ProfileControllerApiFetchParamCreator(configuration).update(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProfileControllerApi - factory interface
 * @export
 */
export const ProfileControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        account(options?: any) {
            return ProfileControllerApiFp(configuration).account(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ClientBlockBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockStatByClient(body: ClientBlockBean, options?: any) {
            return ProfileControllerApiFp(configuration).blockStatByClient(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ChangePasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(bean: ChangePasswordBean, options?: any) {
            return ProfileControllerApiFp(configuration).changePassword(bean, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForEdit(options?: any) {
            return ProfileControllerApiFp(configuration).getForEdit(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payments(options?: any) {
            return ProfileControllerApiFp(configuration).payments(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailConfirmationEmail(options?: any) {
            return ProfileControllerApiFp(configuration).requestEmailConfirmationEmail(options)(fetch, basePath);
        },
        /**
         * 
         * @param {RequestPasswordResetBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(bean: RequestPasswordResetBean, options?: any) {
            return ProfileControllerApiFp(configuration).requestPasswordReset(bean, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ResetPasswordBean} bean 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset1(bean: ResetPasswordBean, options?: any) {
            return ProfileControllerApiFp(configuration).requestPasswordReset1(bean, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendConfirmationEmail(options?: any) {
            return ProfileControllerApiFp(configuration).resendConfirmationEmail(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ContactSupportForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactSupportRequest(body: ContactSupportForm, options?: any) {
            return ProfileControllerApiFp(configuration).sendContactSupportRequest(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uix(options?: any) {
            return ProfileControllerApiFp(configuration).uix(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ProfileForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(body: ProfileForm, options?: any) {
            return ProfileControllerApiFp(configuration).update(body, options)(fetch, basePath);
        },
    };
};

/**
 * ProfileControllerApi - object-oriented interface
 * @export
 * @class ProfileControllerApi
 * @extends {BaseAPI}
 */
export class ProfileControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public account(options?: any) {
        return ProfileControllerApiFp(this.configuration).account(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ClientBlockBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public blockStatByClient(body: ClientBlockBean, options?: any) {
        return ProfileControllerApiFp(this.configuration).blockStatByClient(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ChangePasswordBean} bean 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public changePassword(bean: ChangePasswordBean, options?: any) {
        return ProfileControllerApiFp(this.configuration).changePassword(bean, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public getForEdit(options?: any) {
        return ProfileControllerApiFp(this.configuration).getForEdit(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public payments(options?: any) {
        return ProfileControllerApiFp(this.configuration).payments(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public requestEmailConfirmationEmail(options?: any) {
        return ProfileControllerApiFp(this.configuration).requestEmailConfirmationEmail(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RequestPasswordResetBean} bean 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public requestPasswordReset(bean: RequestPasswordResetBean, options?: any) {
        return ProfileControllerApiFp(this.configuration).requestPasswordReset(bean, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ResetPasswordBean} bean 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public requestPasswordReset1(bean: ResetPasswordBean, options?: any) {
        return ProfileControllerApiFp(this.configuration).requestPasswordReset1(bean, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public resendConfirmationEmail(options?: any) {
        return ProfileControllerApiFp(this.configuration).resendConfirmationEmail(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ContactSupportForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public sendContactSupportRequest(body: ContactSupportForm, options?: any) {
        return ProfileControllerApiFp(this.configuration).sendContactSupportRequest(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public uix(options?: any) {
        return ProfileControllerApiFp(this.configuration).uix(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ProfileForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileControllerApi
     */
    public update(body: ProfileForm, options?: any) {
        return ProfileControllerApiFp(this.configuration).update(body, options)(this.fetch, this.basePath);
    }

}
/**
 * PublicApiControllerApi - fetch parameter creator
 * @export
 */
export const PublicApiControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} apiKey 
         * @param {number} accountId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adRequests(apiKey: string, accountId: number, startDate: string, endDate: string, options: any = {}): FetchArgs {
            // verify required parameter 'apiKey' is not null or undefined
            if (apiKey === null || apiKey === undefined) {
                throw new RequiredError('apiKey','Required parameter apiKey was null or undefined when calling adRequests.');
            }
            // verify required parameter 'accountId' is not null or undefined
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId','Required parameter accountId was null or undefined when calling adRequests.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new RequiredError('startDate','Required parameter startDate was null or undefined when calling adRequests.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new RequiredError('endDate','Required parameter endDate was null or undefined when calling adRequests.');
            }
            const localVarPath = `/public-api/adrequests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiKey !== undefined) {
                localVarQueryParameter['apiKey'] = apiKey;
            }

            if (accountId !== undefined) {
                localVarQueryParameter['accountId'] = accountId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApiControllerApi - functional programming interface
 * @export
 */
export const PublicApiControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} apiKey 
         * @param {number} accountId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adRequests(apiKey: string, accountId: number, startDate: string, endDate: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdRequestsBean> {
            const localVarFetchArgs = PublicApiControllerApiFetchParamCreator(configuration).adRequests(apiKey, accountId, startDate, endDate, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PublicApiControllerApi - factory interface
 * @export
 */
export const PublicApiControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} apiKey 
         * @param {number} accountId 
         * @param {string} startDate 
         * @param {string} endDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adRequests(apiKey: string, accountId: number, startDate: string, endDate: string, options?: any) {
            return PublicApiControllerApiFp(configuration).adRequests(apiKey, accountId, startDate, endDate, options)(fetch, basePath);
        },
    };
};

/**
 * PublicApiControllerApi - object-oriented interface
 * @export
 * @class PublicApiControllerApi
 * @extends {BaseAPI}
 */
export class PublicApiControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} apiKey 
     * @param {number} accountId 
     * @param {string} startDate 
     * @param {string} endDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApiControllerApi
     */
    public adRequests(apiKey: string, accountId: number, startDate: string, endDate: string, options?: any) {
        return PublicApiControllerApiFp(this.configuration).adRequests(apiKey, accountId, startDate, endDate, options)(this.fetch, this.basePath);
    }

}
/**
 * PublisherPublicControllerApi - fetch parameter creator
 * @export
 */
export const PublisherPublicControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {{ [key: string]: string; }} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisherCustomFields(body: { [key: string]: string; }, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePublisherCustomFields.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePublisherCustomFields.');
            }
            const localVarPath = `/api/v1/publisher/custom-fields/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"{ [key: string]: string; }" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublisherPublicControllerApi - functional programming interface
 * @export
 */
export const PublisherPublicControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {{ [key: string]: string; }} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisherCustomFields(body: { [key: string]: string; }, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = PublisherPublicControllerApiFetchParamCreator(configuration).updatePublisherCustomFields(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * PublisherPublicControllerApi - factory interface
 * @export
 */
export const PublisherPublicControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {{ [key: string]: string; }} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePublisherCustomFields(body: { [key: string]: string; }, id: number, options?: any) {
            return PublisherPublicControllerApiFp(configuration).updatePublisherCustomFields(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * PublisherPublicControllerApi - object-oriented interface
 * @export
 * @class PublisherPublicControllerApi
 * @extends {BaseAPI}
 */
export class PublisherPublicControllerApi extends BaseAPI {
    /**
     * 
     * @param {{ [key: string]: string; }} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublisherPublicControllerApi
     */
    public updatePublisherCustomFields(body: { [key: string]: string; }, id: number, options?: any) {
        return PublisherPublicControllerApiFp(this.configuration).updatePublisherCustomFields(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * RegControllerApi - fetch parameter creator
 * @export
 */
export const RegControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createAccount.');
            }
            const localVarPath = `/api/admin/register`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AccountBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegControllerApi - functional programming interface
 * @export
 */
export const RegControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ItemResponseAccountBean> {
            const localVarFetchArgs = RegControllerApiFetchParamCreator(configuration).createAccount(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RegControllerApi - factory interface
 * @export
 */
export const RegControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AccountBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(body: AccountBean, options?: any) {
            return RegControllerApiFp(configuration).createAccount(body, options)(fetch, basePath);
        },
    };
};

/**
 * RegControllerApi - object-oriented interface
 * @export
 * @class RegControllerApi
 * @extends {BaseAPI}
 */
export class RegControllerApi extends BaseAPI {
    /**
     * 
     * @param {AccountBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegControllerApi
     */
    public createAccount(body: AccountBean, options?: any) {
        return RegControllerApiFp(this.configuration).createAccount(body, options)(this.fetch, this.basePath);
    }

}
/**
 * RegistrationControllerApi - fetch parameter creator
 * @export
 */
export const RegistrationControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(code: string, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling emailConfirmation.');
            }
            const localVarPath = `/public-api/emailConfirmation`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(body: RegistrationForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling register.');
            }
            const localVarPath = `/public-api/register`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RegistrationForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RegistrationControllerApi - functional programming interface
 * @export
 */
export const RegistrationControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RedirectView> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).emailConfirmation(code, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(body: RegistrationForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RegistrationResponse> {
            const localVarFetchArgs = RegistrationControllerApiFetchParamCreator(configuration).register(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RegistrationControllerApi - factory interface
 * @export
 */
export const RegistrationControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailConfirmation(code: string, options?: any) {
            return RegistrationControllerApiFp(configuration).emailConfirmation(code, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RegistrationForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(body: RegistrationForm, options?: any) {
            return RegistrationControllerApiFp(configuration).register(body, options)(fetch, basePath);
        },
    };
};

/**
 * RegistrationControllerApi - object-oriented interface
 * @export
 * @class RegistrationControllerApi
 * @extends {BaseAPI}
 */
export class RegistrationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public emailConfirmation(code: string, options?: any) {
        return RegistrationControllerApiFp(this.configuration).emailConfirmation(code, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RegistrationForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationControllerApi
     */
    public register(body: RegistrationForm, options?: any) {
        return RegistrationControllerApiFp(this.configuration).register(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ReportControllerApi - fetch parameter creator
 * @export
 */
export const ReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsCsvReportNew(body: ReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling downloadAuctionsCsvReportNew.');
            }
            const localVarPath = `/api/report/csv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportNew(body: ReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAuctionsJsonReportNew.');
            }
            const localVarPath = `/api/report/json`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportControllerApi - functional programming interface
 * @export
 */
export const ReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsCsvReportNew(body: ReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).downloadAuctionsCsvReportNew(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportNew(body: ReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReportRecords> {
            const localVarFetchArgs = ReportControllerApiFetchParamCreator(configuration).generateAuctionsJsonReportNew(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ReportControllerApi - factory interface
 * @export
 */
export const ReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsCsvReportNew(body: ReportQuery, options?: any) {
            return ReportControllerApiFp(configuration).downloadAuctionsCsvReportNew(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReportNew(body: ReportQuery, options?: any) {
            return ReportControllerApiFp(configuration).generateAuctionsJsonReportNew(body, options)(fetch, basePath);
        },
    };
};

/**
 * ReportControllerApi - object-oriented interface
 * @export
 * @class ReportControllerApi
 * @extends {BaseAPI}
 */
export class ReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {ReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public downloadAuctionsCsvReportNew(body: ReportQuery, options?: any) {
        return ReportControllerApiFp(this.configuration).downloadAuctionsCsvReportNew(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportControllerApi
     */
    public generateAuctionsJsonReportNew(body: ReportQuery, options?: any) {
        return ReportControllerApiFp(this.configuration).generateAuctionsJsonReportNew(body, options)(this.fetch, this.basePath);
    }

}
/**
 * RestorePasswordControllerApi - fetch parameter creator
 * @export
 */
export const RestorePasswordControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RestorePasswordActionForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordAction(body: RestorePasswordActionForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling restorePasswordAction.');
            }
            const localVarPath = `/public-api/restorePasswordAction`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RestorePasswordActionForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RestorePasswordRequestForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordRequest(body: RestorePasswordRequestForm, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling restorePasswordRequest.');
            }
            const localVarPath = `/public-api/restorePasswordRequest`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RestorePasswordRequestForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestorePasswordControllerApi - functional programming interface
 * @export
 */
export const RestorePasswordControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RestorePasswordActionForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordAction(body: RestorePasswordActionForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RestorePasswordActionResponse> {
            const localVarFetchArgs = RestorePasswordControllerApiFetchParamCreator(configuration).restorePasswordAction(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RestorePasswordRequestForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordRequest(body: RestorePasswordRequestForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RestorePasswordRequestResponse> {
            const localVarFetchArgs = RestorePasswordControllerApiFetchParamCreator(configuration).restorePasswordRequest(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * RestorePasswordControllerApi - factory interface
 * @export
 */
export const RestorePasswordControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {RestorePasswordActionForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordAction(body: RestorePasswordActionForm, options?: any) {
            return RestorePasswordControllerApiFp(configuration).restorePasswordAction(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RestorePasswordRequestForm} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restorePasswordRequest(body: RestorePasswordRequestForm, options?: any) {
            return RestorePasswordControllerApiFp(configuration).restorePasswordRequest(body, options)(fetch, basePath);
        },
    };
};

/**
 * RestorePasswordControllerApi - object-oriented interface
 * @export
 * @class RestorePasswordControllerApi
 * @extends {BaseAPI}
 */
export class RestorePasswordControllerApi extends BaseAPI {
    /**
     * 
     * @param {RestorePasswordActionForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestorePasswordControllerApi
     */
    public restorePasswordAction(body: RestorePasswordActionForm, options?: any) {
        return RestorePasswordControllerApiFp(this.configuration).restorePasswordAction(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RestorePasswordRequestForm} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestorePasswordControllerApi
     */
    public restorePasswordRequest(body: RestorePasswordRequestForm, options?: any) {
        return RestorePasswordControllerApiFp(this.configuration).restorePasswordRequest(body, options)(this.fetch, this.basePath);
    }

}
/**
 * SiteControllerApi - fetch parameter creator
 * @export
 */
export const SiteControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling archiveSite.');
            }
            const localVarPath = `/api/site/archive/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createSite.');
            }
            const localVarPath = `/api/site`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SiteBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSite(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSite.');
            }
            const localVarPath = `/api/site/get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteAll(options: any = {}): FetchArgs {
            const localVarPath = `/api/site/listAll`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [domain] 
         * @param {Array<string>} [status] 
         * @param {string} [orderBy] 
         * @param {string} [orderDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteSearch(name?: string, domain?: string, status?: Array<string>, orderBy?: string, orderDirection?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/site/listSearch`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite(body: SiteBean, id: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateSite.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateSite.');
            }
            const localVarPath = `/api/site/update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SiteBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SiteControllerApi - functional programming interface
 * @export
 */
export const SiteControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).archiveSite(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).createSite(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSite(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SiteInfoBean> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).getSite(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteAll(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SiteBean>> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).listSiteAll(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [domain] 
         * @param {Array<string>} [status] 
         * @param {string} [orderBy] 
         * @param {string} [orderDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteSearch(name?: string, domain?: string, status?: Array<string>, orderBy?: string, orderDirection?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ListResponseSiteInfoBean> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).listSiteSearch(name, domain, status, orderBy, orderDirection, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite(body: SiteBean, id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SiteControllerApiFetchParamCreator(configuration).updateSite(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SiteControllerApi - factory interface
 * @export
 */
export const SiteControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveSite(id: number, options?: any) {
            return SiteControllerApiFp(configuration).archiveSite(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSite(body: SiteBean, options?: any) {
            return SiteControllerApiFp(configuration).createSite(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSite(id: number, options?: any) {
            return SiteControllerApiFp(configuration).getSite(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteAll(options?: any) {
            return SiteControllerApiFp(configuration).listSiteAll(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [domain] 
         * @param {Array<string>} [status] 
         * @param {string} [orderBy] 
         * @param {string} [orderDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSiteSearch(name?: string, domain?: string, status?: Array<string>, orderBy?: string, orderDirection?: string, options?: any) {
            return SiteControllerApiFp(configuration).listSiteSearch(name, domain, status, orderBy, orderDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SiteBean} body 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSite(body: SiteBean, id: number, options?: any) {
            return SiteControllerApiFp(configuration).updateSite(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * SiteControllerApi - object-oriented interface
 * @export
 * @class SiteControllerApi
 * @extends {BaseAPI}
 */
export class SiteControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public archiveSite(id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).archiveSite(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SiteBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public createSite(body: SiteBean, options?: any) {
        return SiteControllerApiFp(this.configuration).createSite(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public getSite(id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).getSite(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public listSiteAll(options?: any) {
        return SiteControllerApiFp(this.configuration).listSiteAll(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [name] 
     * @param {string} [domain] 
     * @param {Array<string>} [status] 
     * @param {string} [orderBy] 
     * @param {string} [orderDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public listSiteSearch(name?: string, domain?: string, status?: Array<string>, orderBy?: string, orderDirection?: string, options?: any) {
        return SiteControllerApiFp(this.configuration).listSiteSearch(name, domain, status, orderBy, orderDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SiteBean} body 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteControllerApi
     */
    public updateSite(body: SiteBean, id: number, options?: any) {
        return SiteControllerApiFp(this.configuration).updateSite(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * SitePublicControllerApi - fetch parameter creator
 * @export
 */
export const SitePublicControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteCreateV1(body: SitePublicBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling siteCreateV1.');
            }
            const localVarPath = `/api/v1/site/create`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SitePublicBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteDeleteV1(siteId: number, options: any = {}): FetchArgs {
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling siteDeleteV1.');
            }
            const localVarPath = `/api/v1/site/delete/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByIdV1(siteId: number, options: any = {}): FetchArgs {
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling siteGetByIdV1.');
            }
            const localVarPath = `/api/v1/site/id/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} siteKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByKeyV1(siteKey: string, options: any = {}): FetchArgs {
            // verify required parameter 'siteKey' is not null or undefined
            if (siteKey === null || siteKey === undefined) {
                throw new RequiredError('siteKey','Required parameter siteKey was null or undefined when calling siteGetByKeyV1.');
            }
            const localVarPath = `/api/v1/site/key/{siteKey}`
                .replace(`{${"siteKey"}}`, encodeURIComponent(String(siteKey)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListV1(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/site/list`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteUpdateV1(body: SitePublicBean, siteId: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling siteUpdateV1.');
            }
            // verify required parameter 'siteId' is not null or undefined
            if (siteId === null || siteId === undefined) {
                throw new RequiredError('siteId','Required parameter siteId was null or undefined when calling siteUpdateV1.');
            }
            const localVarPath = `/api/v1/site/update/{siteId}`
                .replace(`{${"siteId"}}`, encodeURIComponent(String(siteId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SitePublicBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitePublicControllerApi - functional programming interface
 * @export
 */
export const SitePublicControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteCreateV1(body: SitePublicBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SitePublicBean> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteCreateV1(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteDeleteV1(siteId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteDeleteV1(siteId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByIdV1(siteId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SitePublicBean> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteGetByIdV1(siteId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} siteKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByKeyV1(siteKey: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SitePublicBean> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteGetByKeyV1(siteKey, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListV1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SitePublicBean>> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteListV1(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteUpdateV1(body: SitePublicBean, siteId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SitePublicControllerApiFetchParamCreator(configuration).siteUpdateV1(body, siteId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SitePublicControllerApi - factory interface
 * @export
 */
export const SitePublicControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteCreateV1(body: SitePublicBean, options?: any) {
            return SitePublicControllerApiFp(configuration).siteCreateV1(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteDeleteV1(siteId: number, options?: any) {
            return SitePublicControllerApiFp(configuration).siteDeleteV1(siteId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByIdV1(siteId: number, options?: any) {
            return SitePublicControllerApiFp(configuration).siteGetByIdV1(siteId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} siteKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteGetByKeyV1(siteKey: string, options?: any) {
            return SitePublicControllerApiFp(configuration).siteGetByKeyV1(siteKey, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteListV1(options?: any) {
            return SitePublicControllerApiFp(configuration).siteListV1(options)(fetch, basePath);
        },
        /**
         * 
         * @param {SitePublicBean} body 
         * @param {number} siteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        siteUpdateV1(body: SitePublicBean, siteId: number, options?: any) {
            return SitePublicControllerApiFp(configuration).siteUpdateV1(body, siteId, options)(fetch, basePath);
        },
    };
};

/**
 * SitePublicControllerApi - object-oriented interface
 * @export
 * @class SitePublicControllerApi
 * @extends {BaseAPI}
 */
export class SitePublicControllerApi extends BaseAPI {
    /**
     * 
     * @param {SitePublicBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteCreateV1(body: SitePublicBean, options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteCreateV1(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteDeleteV1(siteId: number, options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteDeleteV1(siteId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteGetByIdV1(siteId: number, options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteGetByIdV1(siteId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} siteKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteGetByKeyV1(siteKey: string, options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteGetByKeyV1(siteKey, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteListV1(options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteListV1(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SitePublicBean} body 
     * @param {number} siteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitePublicControllerApi
     */
    public siteUpdateV1(body: SitePublicBean, siteId: number, options?: any) {
        return SitePublicControllerApiFp(this.configuration).siteUpdateV1(body, siteId, options)(this.fetch, this.basePath);
    }

}
/**
 * StatControllerApi - fetch parameter creator
 * @export
 */
export const StatControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype(body: FieldChartQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adtype.');
            }
            const localVarPath = `/api/stat/adtype`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FieldChartQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard(body: DashboardQuery, publisherId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling dashboard.');
            }
            const localVarPath = `/api/stat/dashboard`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReport(body: BasicReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling downloadAuctionsReport.');
            }
            const localVarPath = `/api/stat/download/report/auctions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BasicReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReport(body: BasicReportQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateAuctionsJsonReport.');
            }
            const localVarPath = `/api/stat/generate/report/auctions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BasicReportQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBidderFunnelChart.');
            }
            const localVarPath = `/api/stat/bidders/funnel`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBiddersMetricsByTime.');
            }
            const localVarPath = `/api/stat/bidders/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadBiddersResponseTimeChart.');
            }
            const localVarPath = `/api/stat/bidders/responseTime`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadIncrementalRevenueChart.');
            }
            const localVarPath = `/api/stat/bidders/incrementalRevenue`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart(body: DashboardQuery, publisherId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadOverviewChart.');
            }
            const localVarPath = `/api/stat/dashboard/overview`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DashboardQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMCampaignsData(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadUTMCampaignsData.');
            }
            const localVarPath = `/api/stat/utm/campaigns`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMChartData(body: BidderMetricsQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling loadUTMChartData.');
            }
            const localVarPath = `/api/stat/utm/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BidderMetricsQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version(body: FieldChartQuery, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling version.');
            }
            const localVarPath = `/api/stat/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FieldChartQuery" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatControllerApi - functional programming interface
 * @export
 */
export const StatControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype(body: FieldChartQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AdTypeChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).adtype(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard(body: DashboardQuery, publisherId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<DashboardBean> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).dashboard(body, publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReport(body: BasicReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).downloadAuctionsReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReport(body: BasicReportQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JsonReport> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).generateAuctionsJsonReport(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FunnelChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadBidderFunnelChart(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BiddersMetricByTime> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadBiddersMetricsByTime(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<XYChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadBiddersResponseTimeChart(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<IncrementalRevenueChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadIncrementalRevenueChart(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart(body: DashboardQuery, publisherId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OverviewChartsData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadOverviewChart(body, publisherId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMCampaignsData(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UTMChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadUTMCampaignsData(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMChartData(body: BidderMetricsQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UTMChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).loadUTMChartData(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version(body: FieldChartQuery, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<VersionChartData> {
            const localVarFetchArgs = StatControllerApiFetchParamCreator(configuration).version(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StatControllerApi - factory interface
 * @export
 */
export const StatControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adtype(body: FieldChartQuery, options?: any) {
            return StatControllerApiFp(configuration).adtype(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboard(body: DashboardQuery, publisherId?: number, options?: any) {
            return StatControllerApiFp(configuration).dashboard(body, publisherId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAuctionsReport(body: BasicReportQuery, options?: any) {
            return StatControllerApiFp(configuration).downloadAuctionsReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BasicReportQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAuctionsJsonReport(body: BasicReportQuery, options?: any) {
            return StatControllerApiFp(configuration).generateAuctionsJsonReport(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBidderFunnelChart(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadBidderFunnelChart(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersMetricsByTime(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadBiddersMetricsByTime(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadBiddersResponseTimeChart(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadBiddersResponseTimeChart(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadIncrementalRevenueChart(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadIncrementalRevenueChart(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {DashboardQuery} body 
         * @param {number} [publisherId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOverviewChart(body: DashboardQuery, publisherId?: number, options?: any) {
            return StatControllerApiFp(configuration).loadOverviewChart(body, publisherId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMCampaignsData(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadUTMCampaignsData(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {BidderMetricsQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadUTMChartData(body: BidderMetricsQuery, options?: any) {
            return StatControllerApiFp(configuration).loadUTMChartData(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {FieldChartQuery} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        version(body: FieldChartQuery, options?: any) {
            return StatControllerApiFp(configuration).version(body, options)(fetch, basePath);
        },
    };
};

/**
 * StatControllerApi - object-oriented interface
 * @export
 * @class StatControllerApi
 * @extends {BaseAPI}
 */
export class StatControllerApi extends BaseAPI {
    /**
     * 
     * @param {FieldChartQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public adtype(body: FieldChartQuery, options?: any) {
        return StatControllerApiFp(this.configuration).adtype(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardQuery} body 
     * @param {number} [publisherId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public dashboard(body: DashboardQuery, publisherId?: number, options?: any) {
        return StatControllerApiFp(this.configuration).dashboard(body, publisherId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BasicReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public downloadAuctionsReport(body: BasicReportQuery, options?: any) {
        return StatControllerApiFp(this.configuration).downloadAuctionsReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BasicReportQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public generateAuctionsJsonReport(body: BasicReportQuery, options?: any) {
        return StatControllerApiFp(this.configuration).generateAuctionsJsonReport(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadBidderFunnelChart(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadBidderFunnelChart(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadBiddersMetricsByTime(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadBiddersMetricsByTime(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadBiddersResponseTimeChart(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadBiddersResponseTimeChart(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadIncrementalRevenueChart(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadIncrementalRevenueChart(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {DashboardQuery} body 
     * @param {number} [publisherId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadOverviewChart(body: DashboardQuery, publisherId?: number, options?: any) {
        return StatControllerApiFp(this.configuration).loadOverviewChart(body, publisherId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadUTMCampaignsData(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadUTMCampaignsData(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {BidderMetricsQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public loadUTMChartData(body: BidderMetricsQuery, options?: any) {
        return StatControllerApiFp(this.configuration).loadUTMChartData(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {FieldChartQuery} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatControllerApi
     */
    public version(body: FieldChartQuery, options?: any) {
        return StatControllerApiFp(this.configuration).version(body, options)(this.fetch, this.basePath);
    }

}
/**
 * StatFilterControllerApi - fetch parameter creator
 * @export
 */
export const StatFilterControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAdUnitValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/ad-unit`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredBidderValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/bidder`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredCustomFilters(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/custom`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredPublisherValues(search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/publisher`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSiteValues(publisherId?: number, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/site`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSizeValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/size`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredVersionValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/filter/version`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (publisherId !== undefined) {
                localVarQueryParameter['publisherId'] = publisherId;
            }

            if (siteIds) {
                localVarQueryParameter['siteIds'] = siteIds;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatFilterControllerApi - functional programming interface
 * @export
 */
export const StatFilterControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAdUnitValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredAdUnitValues(publisherId, siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredBidderValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredBidderValues(publisherId, siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredCustomFilters(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CustomFilterBean>> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredCustomFilters(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredPublisherValues(search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredPublisherValues(search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSiteValues(publisherId?: number, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredSiteValues(publisherId, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSizeValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredSizeValues(publisherId, siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredVersionValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PageLabelValueBean> {
            const localVarFetchArgs = StatFilterControllerApiFetchParamCreator(configuration).filteredVersionValues(publisherId, siteIds, search, page, count, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StatFilterControllerApi - factory interface
 * @export
 */
export const StatFilterControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredAdUnitValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredAdUnitValues(publisherId, siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredBidderValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredBidderValues(publisherId, siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredCustomFilters(options?: any) {
            return StatFilterControllerApiFp(configuration).filteredCustomFilters(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredPublisherValues(search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredPublisherValues(search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSiteValues(publisherId?: number, search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredSiteValues(publisherId, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredSizeValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredSizeValues(publisherId, siteIds, search, page, count, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [publisherId] 
         * @param {Array<number>} [siteIds] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [count] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filteredVersionValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
            return StatFilterControllerApiFp(configuration).filteredVersionValues(publisherId, siteIds, search, page, count, options)(fetch, basePath);
        },
    };
};

/**
 * StatFilterControllerApi - object-oriented interface
 * @export
 * @class StatFilterControllerApi
 * @extends {BaseAPI}
 */
export class StatFilterControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [publisherId] 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredAdUnitValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredAdUnitValues(publisherId, siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [publisherId] 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredBidderValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredBidderValues(publisherId, siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredCustomFilters(options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredCustomFilters(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredPublisherValues(search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredPublisherValues(search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [publisherId] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredSiteValues(publisherId?: number, search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredSiteValues(publisherId, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [publisherId] 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredSizeValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredSizeValues(publisherId, siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [publisherId] 
     * @param {Array<number>} [siteIds] 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [count] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatFilterControllerApi
     */
    public filteredVersionValues(publisherId?: number, siteIds?: Array<number>, search?: string, page?: number, count?: number, options?: any) {
        return StatFilterControllerApiFp(this.configuration).filteredVersionValues(publisherId, siteIds, search, page, count, options)(this.fetch, this.basePath);
    }

}
/**
 * StatReportControllerApi - fetch parameter creator
 * @export
 */
export const StatReportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportKeys(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/report/keys`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportMetrics(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/report/metrics`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatReportControllerApi - functional programming interface
 * @export
 */
export const StatReportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportKeys(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FilterBean>> {
            const localVarFetchArgs = StatReportControllerApiFetchParamCreator(configuration).getReportKeys(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportMetrics(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FilterBean>> {
            const localVarFetchArgs = StatReportControllerApiFetchParamCreator(configuration).getReportMetrics(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StatReportControllerApi - factory interface
 * @export
 */
export const StatReportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportKeys(options?: any) {
            return StatReportControllerApiFp(configuration).getReportKeys(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportMetrics(options?: any) {
            return StatReportControllerApiFp(configuration).getReportMetrics(options)(fetch, basePath);
        },
    };
};

/**
 * StatReportControllerApi - object-oriented interface
 * @export
 * @class StatReportControllerApi
 * @extends {BaseAPI}
 */
export class StatReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatReportControllerApi
     */
    public getReportKeys(options?: any) {
        return StatReportControllerApiFp(this.configuration).getReportKeys(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatReportControllerApi
     */
    public getReportMetrics(options?: any) {
        return StatReportControllerApiFp(this.configuration).getReportMetrics(options)(this.fetch, this.basePath);
    }

}
/**
 * SupportControllerApi - fetch parameter creator
 * @export
 */
export const SupportControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitCacheStats(options: any = {}): FetchArgs {
            const localVarPath = `/support/adunit-cache-stats`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgencyStringIdToAccounts(options: any = {}): FetchArgs {
            const localVarPath = `/support/migrate-string-id-to-accounts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionCheck(options: any = {}): FetchArgs {
            const localVarPath = `/support/connection-check`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionImpl(options: any = {}): FetchArgs {
            const localVarPath = `/support/connection-impl`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillAccountNames(options: any = {}): FetchArgs {
            const localVarPath = `/support/fill-account-names`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agencyStringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdminsToManagers(agencyStringId: string, options: any = {}): FetchArgs {
            // verify required parameter 'agencyStringId' is not null or undefined
            if (agencyStringId === null || agencyStringId === undefined) {
                throw new RequiredError('agencyStringId','Required parameter agencyStringId was null or undefined when calling migrateAdminsToManagers.');
            }
            const localVarPath = `/support/migrate-admins-to-managers/{agencyStringId}`
                .replace(`{${"agencyStringId"}}`, encodeURIComponent(String(agencyStringId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportControllerApi - functional programming interface
 * @export
 */
export const SupportControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitCacheStats(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).adUnitCacheStats(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgencyStringIdToAccounts(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).addAgencyStringIdToAccounts(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionCheck(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).connectionCheck(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionImpl(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).connectionImpl(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillAccountNames(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).fillAccountNames(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} agencyStringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdminsToManagers(agencyStringId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = SupportControllerApiFetchParamCreator(configuration).migrateAdminsToManagers(agencyStringId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SupportControllerApi - factory interface
 * @export
 */
export const SupportControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adUnitCacheStats(options?: any) {
            return SupportControllerApiFp(configuration).adUnitCacheStats(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgencyStringIdToAccounts(options?: any) {
            return SupportControllerApiFp(configuration).addAgencyStringIdToAccounts(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionCheck(options?: any) {
            return SupportControllerApiFp(configuration).connectionCheck(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        connectionImpl(options?: any) {
            return SupportControllerApiFp(configuration).connectionImpl(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fillAccountNames(options?: any) {
            return SupportControllerApiFp(configuration).fillAccountNames(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} agencyStringId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        migrateAdminsToManagers(agencyStringId: string, options?: any) {
            return SupportControllerApiFp(configuration).migrateAdminsToManagers(agencyStringId, options)(fetch, basePath);
        },
    };
};

/**
 * SupportControllerApi - object-oriented interface
 * @export
 * @class SupportControllerApi
 * @extends {BaseAPI}
 */
export class SupportControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public adUnitCacheStats(options?: any) {
        return SupportControllerApiFp(this.configuration).adUnitCacheStats(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public addAgencyStringIdToAccounts(options?: any) {
        return SupportControllerApiFp(this.configuration).addAgencyStringIdToAccounts(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public connectionCheck(options?: any) {
        return SupportControllerApiFp(this.configuration).connectionCheck(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public connectionImpl(options?: any) {
        return SupportControllerApiFp(this.configuration).connectionImpl(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public fillAccountNames(options?: any) {
        return SupportControllerApiFp(this.configuration).fillAccountNames(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} agencyStringId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportControllerApi
     */
    public migrateAdminsToManagers(agencyStringId: string, options?: any) {
        return SupportControllerApiFp(this.configuration).migrateAdminsToManagers(agencyStringId, options)(this.fetch, this.basePath);
    }

}
/**
 * TestDataControllerApi - fetch parameter creator
 * @export
 */
export const TestDataControllerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TestDataBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser(body: TestDataBean, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling generateTestDataForUser.');
            }
            const localVarPath = `/api/admin/generate-test-data`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TestDataBean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} amountMin 
         * @param {number} amountMax 
         * @param {number} bidRateMin 
         * @param {number} bidRateMax 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser1(userId: number, amountMin: number, amountMax: number, bidRateMin: number, bidRateMax: number, dateStart: string, dateEnd: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'amountMin' is not null or undefined
            if (amountMin === null || amountMin === undefined) {
                throw new RequiredError('amountMin','Required parameter amountMin was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'amountMax' is not null or undefined
            if (amountMax === null || amountMax === undefined) {
                throw new RequiredError('amountMax','Required parameter amountMax was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'bidRateMin' is not null or undefined
            if (bidRateMin === null || bidRateMin === undefined) {
                throw new RequiredError('bidRateMin','Required parameter bidRateMin was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'bidRateMax' is not null or undefined
            if (bidRateMax === null || bidRateMax === undefined) {
                throw new RequiredError('bidRateMax','Required parameter bidRateMax was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'dateStart' is not null or undefined
            if (dateStart === null || dateStart === undefined) {
                throw new RequiredError('dateStart','Required parameter dateStart was null or undefined when calling generateTestDataForUser1.');
            }
            // verify required parameter 'dateEnd' is not null or undefined
            if (dateEnd === null || dateEnd === undefined) {
                throw new RequiredError('dateEnd','Required parameter dateEnd was null or undefined when calling generateTestDataForUser1.');
            }
            const localVarPath = `/api/admin/generate-demo-data`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (amountMin !== undefined) {
                localVarQueryParameter['amountMin'] = amountMin;
            }

            if (amountMax !== undefined) {
                localVarQueryParameter['amountMax'] = amountMax;
            }

            if (bidRateMin !== undefined) {
                localVarQueryParameter['bidRateMin'] = bidRateMin;
            }

            if (bidRateMax !== undefined) {
                localVarQueryParameter['bidRateMax'] = bidRateMax;
            }

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = dateEnd;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial(dateStart: string, dateEnd: string, options: any = {}): FetchArgs {
            // verify required parameter 'dateStart' is not null or undefined
            if (dateStart === null || dateStart === undefined) {
                throw new RequiredError('dateStart','Required parameter dateStart was null or undefined when calling generateTestDataPartial.');
            }
            // verify required parameter 'dateEnd' is not null or undefined
            if (dateEnd === null || dateEnd === undefined) {
                throw new RequiredError('dateEnd','Required parameter dateEnd was null or undefined when calling generateTestDataPartial.');
            }
            const localVarPath = `/api/admin/generate-demo-data-partial`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateStart !== undefined) {
                localVarQueryParameter['dateStart'] = dateStart;
            }

            if (dateEnd !== undefined) {
                localVarQueryParameter['dateEnd'] = dateEnd;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial1(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/generate-demo-data-now`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestDataControllerApi - functional programming interface
 * @export
 */
export const TestDataControllerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TestDataBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser(body: TestDataBean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TestDataControllerApiFetchParamCreator(configuration).generateTestDataForUser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} amountMin 
         * @param {number} amountMax 
         * @param {number} bidRateMin 
         * @param {number} bidRateMax 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser1(userId: number, amountMin: number, amountMax: number, bidRateMin: number, bidRateMax: number, dateStart: string, dateEnd: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TestDataControllerApiFetchParamCreator(configuration).generateTestDataForUser1(userId, amountMin, amountMax, bidRateMin, bidRateMax, dateStart, dateEnd, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial(dateStart: string, dateEnd: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TestDataControllerApiFetchParamCreator(configuration).generateTestDataPartial(dateStart, dateEnd, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial1(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TestDataControllerApiFetchParamCreator(configuration).generateTestDataPartial1(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TestDataControllerApi - factory interface
 * @export
 */
export const TestDataControllerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {TestDataBean} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser(body: TestDataBean, options?: any) {
            return TestDataControllerApiFp(configuration).generateTestDataForUser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {number} amountMin 
         * @param {number} amountMax 
         * @param {number} bidRateMin 
         * @param {number} bidRateMax 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataForUser1(userId: number, amountMin: number, amountMax: number, bidRateMin: number, bidRateMax: number, dateStart: string, dateEnd: string, options?: any) {
            return TestDataControllerApiFp(configuration).generateTestDataForUser1(userId, amountMin, amountMax, bidRateMin, bidRateMax, dateStart, dateEnd, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} dateStart 
         * @param {string} dateEnd 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial(dateStart: string, dateEnd: string, options?: any) {
            return TestDataControllerApiFp(configuration).generateTestDataPartial(dateStart, dateEnd, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTestDataPartial1(options?: any) {
            return TestDataControllerApiFp(configuration).generateTestDataPartial1(options)(fetch, basePath);
        },
    };
};

/**
 * TestDataControllerApi - object-oriented interface
 * @export
 * @class TestDataControllerApi
 * @extends {BaseAPI}
 */
export class TestDataControllerApi extends BaseAPI {
    /**
     * 
     * @param {TestDataBean} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDataControllerApi
     */
    public generateTestDataForUser(body: TestDataBean, options?: any) {
        return TestDataControllerApiFp(this.configuration).generateTestDataForUser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} userId 
     * @param {number} amountMin 
     * @param {number} amountMax 
     * @param {number} bidRateMin 
     * @param {number} bidRateMax 
     * @param {string} dateStart 
     * @param {string} dateEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDataControllerApi
     */
    public generateTestDataForUser1(userId: number, amountMin: number, amountMax: number, bidRateMin: number, bidRateMax: number, dateStart: string, dateEnd: string, options?: any) {
        return TestDataControllerApiFp(this.configuration).generateTestDataForUser1(userId, amountMin, amountMax, bidRateMin, bidRateMax, dateStart, dateEnd, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} dateStart 
     * @param {string} dateEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDataControllerApi
     */
    public generateTestDataPartial(dateStart: string, dateEnd: string, options?: any) {
        return TestDataControllerApiFp(this.configuration).generateTestDataPartial(dateStart, dateEnd, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDataControllerApi
     */
    public generateTestDataPartial1(options?: any) {
        return TestDataControllerApiFp(this.configuration).generateTestDataPartial1(options)(this.fetch, this.basePath);
    }

}
